/*
 * サブシステム名：
 * 機能名：配車表入力
 */
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
// import validators from '@/rahmen/validators'

import d2fmt from '@/ddv2.library/utils/formatter'
import date from '@/ddv2.library/date'
import header from '@/ddv2.library/header'
import indexeddb from '@/ddv2.library/indexeddb'
import modals from '@/ddv2.library/modals'

import DdCustomButton from '@/components/DdCustomButton'
import DdCheckbox from '@/components/DdCheckbox'
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdDateBox from '@/components/DdDateBox'
import DdDateRangeBox from '@/components/DdDateRangeBox'
import DdDropDown from '@/components/DdDropDown'
import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'
import DdMonthBox from '@/components/DdMonthBox'
import DdMonthBoxInside from '@/components/DdMonthBoxInside'
import DdRadioButton from '@/components/DdRadioButton'
import DdRadioSwitchTwoway from '@/components/DdRadioSwitchTwoway'
import DdSpreadSheet from '@/components/DdSpreadSheet'
import DdSubHeader from '@/components/DdSubHeader'
import DdSwitch from '@/components/DdSwitch'
import DdTransparentButton from '@/components/DdTransparentButton'
import VTour from '@/components/DdCoachMark.vue'
import CoachMark from './CoachMark/D2PLMT1010.js'
import DdXlsTemplateEditDialog from '@/components/DdXlsTemplateEditDialog'
import DdXlsTemplateSearchDialog from '@/components/DdXlsTemplateSearchDialog'

export default {
  name: 'HaishaMeisaiListEdit',
  mixins: [flowMixin],
  components: {
    VTour,
    DdCustomButton,
    DdCheckbox,
    DdCodeTextBox,
    DdDateBox,
    DdDateRangeBox,
    DdDropDown,
    DdIconButtonWithTooltip,
    DdMonthBox,
    DdMonthBoxInside,
    DdRadioButton,
    DdRadioSwitchTwoway,
    DdSpreadSheet,
    DdSubHeader,
    DdSwitch,
    DdTransparentButton,
    DdXlsTemplateEditDialog,
    DdXlsTemplateSearchDialog
  },
  data: () => ({
    isConditionHide: false,
    isAfterSearch: false,
    isEditCategory: false,
    isShowHaishaOutputDialog: false,
    isShowNohinshoOutputDialog: false,
    isShowOutputDialog: false,
    isXlsDownloader: false,

    // ヘッダー定義
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstJininHeaders: header.mstJininHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders,
    mstSharyoHeaders: header.vwCMstSharyoHeaders,
    mstHinmeiHeaders: header.mstHinmeiHeaders,

    unkoYmdMultiFlg: false,

    // 検索用
    conditions: {},
    conditionDetails: [
      { key: 'layoutType', name: 'レイアウト', value: 'layoutTypeNm', delete: false },
      // { key: 'sagyoYoteiYmd', name: '運行日', value: 'sagyoYoteiYmd', delete: false },
      // { key: 'unkoYmdFromTo', name: '運行日', value: 'unkoYmdFromTo', delete: false },
      { key: 'haishahyoCd', name: '配車表', value: 'haishahyoNm', delete: true },
      { key: 'haishaEigyoshoId', name: '配車営業所', value: 'haishaEigyoshoNm', delete: true },
      { key: 'sharyoId', name: '車両', value: 'sharyoNm', delete: true },
      { key: 'jininId1', name: '乗務員', value: 'jininNm1', delete: true },
      { key: 'tokuisakiId', name: '得意先', value: 'tokuisakiNm', delete: true },
      { key: 'mstHinmeiId', name: '品名', value: 'mstHinmeiNm', delete: true }
      // { key: 'tableStartHourDisp', name: '開始時間', value: 'tableStartHourDisp', delete: false },
      // { key: 'rangeDisp', name: '表示範囲', value: 'rangeDisp', delete: false }
    ],
    searchText: null,

    // 初期表示用時間定義
    tableStartHourDisp: '6:00',
    // tableStartHour: 6, - computedへ
    rangeDisp: '24時間',
    rangeDispList: ['24時間', '48時間', '3日', '5日', '7日'],

    // 表示用
    headers: [],
    rows: [],

    // Formula
    seikyuKingakuGokeiFormula: null,
    shiharaiKingakuGokeiFormula: null,

    // 保存用
    selected: [],
    targetList: [],

    // ソート用
    isSorting: false,

    searchResultList: [],
    // 制御用運行実績ID（新規の場合は-1から減らしていく）
    newRecordId: 0,
    // 操作ガイド用
    startCoachMark: false,
    steps: CoachMark.STEPS,
    startCoachMark2: false,
    steps2: CoachMark.STEPS2,

    modeKengen: 0,

    // 帳票用定義
    isHaishaPdfDownloader: false,
    isNohinshoPdfDownloader: false,
    haishaChohyoSbt: '0',
    nohinshoChohyoSbt: '99',
    dispPdfNm: '',
    // スプレッドシートオプション
    option: {
      // テーブル最大高さ
      tableHeight: '100%',
      // テーブル最大横幅
      tableWidth: 'inherit',
      // 列固定
      freezeColumns: 1,
      // 列追加
      allowInsertColumn: false,
      // 行追加※改行キーのみ
      allowManualInsertRow: false,
      // 列削除
      allowDeleteColumn: false,
      // 行削除
      allowDeleteRow: true,
      // 列ドラッグ
      columnDrag: false,
      // 行ドラッグ
      rowDrag: false,
      // ソート
      columnSorting: true,
      // スクロール有効化
      tableOverflow: true,
      // コンテキストメニュー
      contextmenu: false,
      // セル内HTML無効※ヘッダー改行のため有効
      stripHTML: false,
      // 計算式のサポート
      parseFormulas: true,
      // セル選択時の右下の■ドラッグでのコピー
      selectionCopy: true,
      // CSV出力
      allowExport: false,
      // フィルターオプション
      search: true,
      // ページネーションオプション
      pagination: 25,
      paginationOptions: [10, 25, 50, 100, 150, 200],
      // デフォルト文言変更
      text: {
        show: '1ページ当たりの行数:',
        entries: '',
        showingPage: '全部で {1} ページあります',
        search: 'さらにフリーワードで絞り込む',
        noRecordsFound: '対象データがありません'
      }
    },
    // 画面側からのエラーリスト
    outsideErrorList: [],
    customContextMenu: {
      title: '納品書・受領書出力',
      eventNm: 'print'
    },
    customToolbarItem: [],
    // ヘッダー部一番左に配置するツールバー項目(顧客カスタマイズで使用)
    customToolbarItemPrepend: [],

    isShowXlsTemplateEditDialog: false,
    isShowXlsTemplateSearchDialog: false
  }),
  watch: {
    /**
     * 検索条件簡易表示用
     * @param {} n
     */
    // レイアウト
    'conditions.layoutType': function (n) {
      if ([undefined, null, ''].includes(this.conditions.layoutType)) {
        this.conditions.layoutTypeNm = null
      } else {
        const self = this
        const xlsFomatList = this.kubunList.filter(function (item) {
          return item.kaishaCd === self.currentKaishaCode && item.kbnShuruiCd === 'XLSF00' && item.komoku1 === self.conditions.layoutType
        })
        if (xlsFomatList !== null && xlsFomatList.length > 0) {
          this.conditions.layoutTypeNm = xlsFomatList[0].codeNm
        } else if (this.unkoYmdMultiFlg) {
          this.conditions.layoutTypeNm = '日付指定'
        } else {
          this.conditions.layoutTypeNm = '当日用'
        }
      }
    },
    // 運行日From
    'conditions.sagyoYoteiYmdFrom': function (n) {
      var unkoYmdFromTo = ![undefined, null, ''].includes(this.conditions.sagyoYoteiYmdFrom) ? this.conditions.sagyoYoteiYmdFrom.slice(-5) : ''
      unkoYmdFromTo = unkoYmdFromTo + (![undefined, null, ''].includes(this.conditions.sagyoYoteiYmdTo) ? '～' + this.conditions.sagyoYoteiYmdTo.slice(-5) : '')
      this.conditions.unkoYmdFromTo = unkoYmdFromTo
    },
    // 運行日To
    'conditions.sagyoYoteiYmdTo': function (n) {
      var unkoYmdFromTo = ![undefined, null, ''].includes(this.conditions.sagyoYoteiYmdFrom) ? this.conditions.sagyoYoteiYmdFrom.slice(-5) : ''
      unkoYmdFromTo = unkoYmdFromTo + (![undefined, null, ''].includes(this.conditions.sagyoYoteiYmdTo) ? '～' + this.conditions.sagyoYoteiYmdTo.slice(-5) : '')
      this.conditions.unkoYmdFromTo = unkoYmdFromTo
    },

    // 配車表
    'conditions.haishahyoCd': function (n) {
      if ([undefined, null, ''].includes(this.conditions.haishahyoCd)) {
        this.conditions.haishahyoNm = null
      } else {
        const m = this.haishahyoList.find(x => x.haishahyoCd === this.conditions.haishahyoCd)
        if (m !== null) {
          this.conditions.haishahyoNm = m.haishahyoNm
        } else {
          this.conditions.haishahyoNm = null
        }
      }
    },
    // 配車営業所
    'conditions.haishaEigyoshoId': function (n) {
      if ([undefined, null, ''].includes(this.conditions.haishaEigyoshoId)) {
        this.conditions.haishaEigyoshoNm = null
      } else {
        const m = this.eigyoshoList.find(x => x.id === this.conditions.haishaEigyoshoId)
        if (m !== null) {
          this.conditions.haishaEigyoshoNm = m.eigyoshoNm
        } else {
          this.conditions.haishaEigyoshoNm = null
        }
      }
    },
    // 車両
    'conditions.sharyoId': function (n) {
      if ([undefined, null, ''].includes(this.conditions.sharyoId)) {
        this.conditions.sharyoNm = null
      } else {
        const m = this.sharyoList.find(x => x.id === this.conditions.sharyoId)
        if (m !== null) {
          this.conditions.sharyoNm = m.jidoshaHyojiNm
        } else {
          this.conditions.sharyoNm = null
        }
      }
    },
    // 乗務員
    'conditions.jininId1': function (n) {
      if ([undefined, null, ''].includes(this.conditions.jininId1)) {
        this.conditions.jininNm1 = null
      } else {
        const m = this.eigyoshoJininList.find(x => x.id === this.conditions.jininId1)
        if (m !== null) {
          this.conditions.jininNm1 = m.jininNmSei
        } else {
          this.conditions.jininNm1 = null
        }
      }
    },
    // 得意先
    'conditions.tokuisakiId': function (n) {
      if ([undefined, null, ''].includes(this.conditions.tokuisakiId)) {
        this.conditions.tokuisakiNm = null
      } else {
        const m = this.filteredTokuisakiList.find(x => x.id === this.conditions.tokuisakiId)
        if (m !== null) {
          this.conditions.tokuisakiNm = m.torihikisakiNm
        } else {
          this.conditions.tokuisakiNm = null
        }
      }
    },
    // 品名
    'conditions.mstHinmeiId': function (n) {
      if ([undefined, null, ''].includes(this.conditions.mstHinmeiId)) {
        this.conditions.mstHinmeiNm = null
      } else {
        const m = this.hinmeiList.find(x => x.id === this.conditions.mstHinmeiId)
        if (m !== null) {
          this.conditions.mstHinmeiNm = m.hinmeiNm
        } else {
          this.conditions.mstHinmeiNm = null
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      currentKaishaCode: 'users/currentKaishaCode',
      usersEigyoshoCd: 'users/eigyoshoCd',
      eigyoshoList: 'DDMasters/mstEigyosho',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      haishahyoList: 'DDMasters/mstHaishahyo',
      haishahyoSharyoList: 'DDMasters/vwCMstHaishahyoSharyo',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      sharyoList: 'DDMasters/vwCMstSharyo',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      hinmeiList: 'DDMasters/mstHinmei',
      xlsImportMappingList: 'DDMasters/mstXlsImportMapping',
      shubetsuList: 'DDMasters/mstShubetsu',
      kubunList: 'DDMasters/msysKubun',
      xlsTemplateKihonList: 'DDMasters/mstXlsTemplateKihon',
      teikeiCourseList: 'DDMasters/vwCD2mstd0460',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg'
    }),
    eigyoshoReadOnly () {
      return !this.eigyoshoLockFlg
    },
    // ----------------------------------------------------------------------------------------------------
    // 検索条件用フィルタ
    // ----------------------------------------------------------------------------------------------------
    filteredLayoutList () {
      const self = this
      const xlsFomatList = this.kubunList.filter(function (item) {
        return item.kaishaCd === self.currentKaishaCode && item.kbnShuruiCd === 'XLSF00'
      })
      const resultArray = xlsFomatList.map(elem => {
        return {
          value: elem.komoku1,
          text: `${elem.codeNm}`
        }
      })
      return resultArray
    },
    // 営業所
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03'
      })
    },
    // 配車表フィルター
    filteredHaishaHyoList () {
      var defArray = [{ value: null, text: '未選択' }]
      const resultArray = this.haishahyoList.map(elem => {
        return {
          value: elem.haishahyoCd,
          text: `${elem.haishahyoCd}:${elem.haishahyoNm}`
        }
      })
      return defArray.concat(resultArray)
    },
    // 車両フィルタ
    filteredMstSharyoList () {
      const target = filter.dateFormatter(new Date())
      const self = this
      return this.sharyoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && (self.eigyoshoLockFlg || elem.eigyoshoCd === self.usersEigyoshoCd)
      })
    },
    // 乗務員フィルター
    filteredJininList () {
      const target = filter.dateFormatter(new Date())
      const self = this
      return this.eigyoshoJininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03' && elem.jomuFlg && (self.eigyoshoLockFlg || elem.eigyoshoCd === self.usersEigyoshoCd)
      })
    },
    // 品名
    filteredHinmeiList () {
      const target = filter.dateFormatter(new Date())
      return this.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 開始時間
    filterdStartHour () {
      // return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23]
      var hourArray = ['0:00']
      for (let h = 1; h < 24; h++) {
        hourArray.push(String(h) + ':00')
      }
      return hourArray
    },
    // 表示範囲
    filterdHours () {
      return [8, 12, 24, 48, 72, 96]
    },
    // 取引先フィルター
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    // 得意先フィルター
    filteredTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
      })
    },
    // 傭車先
    filteredHacchusakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hacchusakiFlg === true
      })
    },

    // 定型コースフィルター
    filteredTeikeiCourseList () {
      const self = this
      return this.teikeiCourseList.map((elem) => {
        if (elem.tokuisakiId) { elem.tokuisakiDisp = elem.tokuisakiNm }
        elem.hinmeiDisp = elem.mstHinmeiId ? elem.hinmeiNm : elem.hinmeiBiko
        elem.hatsuchiDisp = elem.hatsuchiId ? elem.hatsuchiNm : elem.hatsuchiBiko
        elem.chakuchiDisp = elem.chakuchiId ? elem.chakuchiNm : elem.chakuchiBiko
        elem.keiyuchiId1Disp = elem.keiyuchiId1 ? elem.keiyuchiId1Nm : elem.keiyuchiBiko1
        if (elem.tantoEigyoshoId) { elem.tantoEigyoshoDisp = elem.tantoEigyoshoNm }
        elem.hatsuchiHmsDisp = elem.hatsuchiHms ? (elem.hatsuchiHms).slice(0, 5) : elem.hatsuchiHmsBiko
        elem.chakuchiHmsDisp = elem.chakuchiHms ? (elem.chakuchiHms).slice(0, 5) : elem.chakuchiHmsBiko
        if (elem.juchuSuryo) { elem.juchuSuryo = filter.numericFormatter(elem.juchuSuryo) }
        if (elem.juchuJuryo) { elem.juchuJuryo = filter.numericFormatter(elem.juchuJuryo) }
        if (elem.tanka) { elem.tanka = filter.numericFormatter(elem.tanka) }
        if (elem.kihonUnchin) { elem.kihonUnchin = filter.numericFormatter(elem.kihonUnchin) }
        if (elem.hiwayPrice) { elem.hiwayPrice = filter.numericFormatter(elem.hiwayPrice) }
        if (elem.unchinHokaKingaku) { elem.unchinHokaKingaku = filter.numericFormatter(elem.unchinHokaKingaku) }
        if (elem.unchinHokaHikazei) { elem.unchinHokaHikazei = filter.numericFormatter(elem.unchinHokaHikazei) }
        if (elem.nenryoSurcharge) { elem.nenryoSurcharge = filter.numericFormatter(elem.nenryoSurcharge) }
        if (elem.tsumikomiKingaku) { elem.tsumikomiKingaku = filter.numericFormatter(elem.tsumikomiKingaku) }
        if (elem.torioroshiKingaku) { elem.torioroshiKingaku = filter.numericFormatter(elem.torioroshiKingaku) }
        elem.taikiJikanDisp = elem.taikiJikan ? filter.minToIntervalTimeFormatter(elem.taikiJikan) : null
        if (elem.taikiJikanTanka) { elem.taikiJikanTanka = filter.numericFormatter(elem.taikiJikanTanka) }
        if (elem.taikiJikanKingaku) { elem.taikiJikanKingaku = filter.numericFormatter(elem.taikiJikanKingaku) }
        if (elem.futaiGyomuKingaku) { elem.futaiGyomuKingaku = filter.numericFormatter(elem.futaiGyomuKingaku) }
        if (elem.jikanWarimashiKingaku) { elem.jikanWarimashiKingaku = filter.numericFormatter(elem.jikanWarimashiKingaku) }
        if (elem.kyoriWarimashiKingaku) { elem.kyoriWarimashiKingaku = filter.numericFormatter(elem.kyoriWarimashiKingaku) }
        if (elem.warimashiSonotaKingaku) { elem.warimashiSonotaKingaku = filter.numericFormatter(elem.warimashiSonotaKingaku) }
        if (elem.seikyuGokei) { elem.seikyuGokei = filter.numericFormatter(elem.seikyuGokei) }
        if (elem.yoshaUnchin) { elem.yoshaUnchin = filter.numericFormatter(elem.yoshaUnchin) }
        if (elem.yoshaHiwayPrice) { elem.yoshaHiwayPrice = filter.numericFormatter(elem.yoshaHiwayPrice) }
        if (elem.yoshaUnchinHokaKingaku) { elem.yoshaUnchinHokaKingaku = filter.numericFormatter(elem.yoshaUnchinHokaKingaku) }
        if (elem.yoshaUnchinHokaHikazei) { elem.yoshaUnchinHokaHikazei = filter.numericFormatter(elem.yoshaUnchinHokaHikazei) }
        if (elem.shiharaiGokei) { elem.shiharaiGokei = filter.numericFormatter(elem.shiharaiGokei) }
        return elem
      }).filter(function (elem) {
        return (self.eigyoshoLockFlg || elem.tantoEigyoshoCd === self.usersEigyoshoCd || [undefined, null, ''].includes(elem.tantoEigyoshoCd))
      }).sort((a, b) => {
        if (a.teikeiCourseNo < b.teikeiCourseNo) { return -1 }
        if (a.teikeiCourseNo > b.teikeiCourseNo) { return 1 }
        return 0
      })
    },

    computedInputRows () {
      return this.rows.filter((elem) => { return ![undefined, null, ''].includes(elem.sagyoYoteiYmd) }).length
    },

    computedColNumList () {
      var result = {}
      this.headers.forEach((elem, index) => {
        result[elem.name] = index
      })
      return result
    },
    isOutputButtonDisabled () {
      return this.rows.length === 0
    },
    isMultiSaveButtonDisabled () {
      if (this.modeKengen !== 2) {
        return false
      }
      const errorRows = this.rows.filter(function (elem) {
        return elem.editFlg === true && elem.errFlg === true
      })
      if (errorRows.length > 0) {
        return true
      }

      const saveTargetRow = this.rows.filter(function (elem) {
        return elem.editFlg === true
      })
      if (saveTargetRow.length < 1) {
        return true
      }
      return false
    },
    filteredRegisterTargetHeaders () {
      return this.headers.filter(elem => !elem.readOnly)
    }
  },
  created () {
    // エクセルレイアウトは常に最新を取得
    this.$store.dispatch('DDMasters/truncateMasters', { list: ['mstxlsimportmapping'] }).then(() => {
      this.$store.dispatch('DDMasters/loadMasters', { list: ['mstxlsimportmapping'], version: 1, kinoId: 0 }).then(() => {
        this.initialize()
      })
    })
  },
  mounted () {
    // カスタムツールバー設定
    const unchinAutoCalcButton = {
      type: 'button',
      class: 'btn-calc',
      content: '<i class="v-icon notranslate mdi mdi-calculator-variant-outline theme--light"/><span class="toolbar_button">運賃自動計算</span>',
      onclick: () => this.onAutoCalcButtonClick(),
      tooltip: '入力情報を元に発着地単価マスタを参照して運賃を自動計算します。'
    }
    if (this.isUnchinAutoCalcButtonPrepend()) {
      // ヘッダー部一番左に配置(顧客カスタマイズでtrueにした場合)
      this.customToolbarItemPrepend = [
        unchinAutoCalcButton,
        { type: 'divisor' }
      ]
    } else {
      this.customToolbarItem = [
        { type: 'divisor' },
        unchinAutoCalcButton
      ]
    }

    // エクセルレイアウトは常に最新を取得
    this.$store.dispatch('DDMasters/truncateMasters', { list: ['mstxlsimportmapping'] }).then(() => {
      this.$store.dispatch('DDMasters/loadMasters', { list: ['mstxlsimportmapping'], version: 1, kinoId: 0 }).then(() => {
        this.initialize()
      })
    })
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    /**
     * 運賃自動計算ボタンをツールバー一番左に配置するか
     * 顧客カスタマイズでtrueを返すようoverrideする
     */
    isUnchinAutoCalcButtonPrepend: function () {
      return false
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'vwcmsteigyoshojininlist', 'msthaishahyo', 'vwcmsthaishahyosharyo', 'msttorihikisaki', 'vwcmstsharyo', 'msthacchakuchi', 'msthinmei', 'mstshubetsu', 'msyskubun', 'mstxlstemplatekihon', 'vwcd2mstd0460'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            self.setHeader()
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
            }
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      const self = this
      const d = new Date()
      const xlsFomatList = self.kubunList.filter(function (item) {
        return item.kaishaCd === self.currentKaishaCode && item.kbnShuruiCd === 'XLSF00' && item.komoku5 === 'DEFAULT'
      })
      var defaultLayoutType = 'D2PLMD1010'
      var defaultLayoutTypeNm = '当日用'
      if (xlsFomatList.length > 0) {
        defaultLayoutType = xlsFomatList[0].komoku1
        defaultLayoutTypeNm = xlsFomatList[0].codeNm
        self.unkoYmdMultiFlg = defaultLayoutType !== 'D2PLMD1010'
      }

      const initConditions = {
        layoutType: defaultLayoutType,
        sagyoYoteiYmd: date.getCurrentDate(),
        sagyoYoteiYmdFrom: date.getFirstDate(d.getFullYear(), d.getMonth() + 1),
        sagyoYoteiYmdTo: date.getLastDate(d.getFullYear(), d.getMonth() + 1),
        haishaEigyoshoId: self.eigyoshoReadOnly ? indexeddb.getRecordByCd(self.currentKaishaCode, self.filteredEigyoshoList, 'eigyoshoCd', self.usersEigyoshoCd, date.getCurrentDate()).id : null,
        haishahyoCd: null,
        eigyoshoId: null,
        tokuisakiId: null,
        tableStartHourDisp: '6:00',
        rangeDisp: self.rangeDisp
      }
      self.conditions = {
        ...initConditions,
        // 表示用
        unkoYmdFromTo: initConditions.sagyoYoteiYmdFrom.slice(-5) + '～' + initConditions.sagyoYoteiYmdTo.slice(-5),
        layoutTypeNm: defaultLayoutTypeNm,
        haishahyoNm: null,
        haishaEigyoshoNm: null,
        sharyoNm: null,
        jomuinNm: null,
        tokuisakiNm: null,
        mstHinmeiNm: null
      }
      self.onChangeListType(self.conditions.layoutType !== 'D2PLMD1010')
      self.isAfterSearch = false
      self.haishaChohyoSbt = '0'
      self.nohinshoChohyoSbt = '99'
      self.searchText = ''
      self.rows = []
      self.searchResultList = []
      self.page = 1
    },

    onClearButtonClick: function () {
      this.clear()
      this.setHeader()
    },
    clear: function () {
      this.initBindVariables()
      this.rows = []
      this.isConditionHide = false
    },
    onSearchButtonClick: function () {
      this.$nextTick(() => {
        if (this.conditions.haishaEigyoshoId && !this.conditions.haishaEigyoshoNm) {
          const m = this.eigyoshoList.find(x => x.id === this.conditions.haishaEigyoshoId)
          if (m !== null) {
            this.conditions.haishaEigyoshoNm = m.eigyoshoNm
          }
        }
        this.searchAction(false)
      })
    },
    onRemoveConditionClick: function (itemNm) {
      this.conditions[itemNm] = null
      this.$nextTick(() => {
        this.searchAction(false)
      })
    },
    searchAction: function (noMessage) {
      const self = this
      self.conditions.unkoYmdMultiFlg = self.unkoYmdMultiFlg
      self.rows = []
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2plmd1000/search', self.conditions)
              .then(async (data) => {
                await self.setHeader()
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          const resultData = data.payload
          // 検索結果保持用にセット
          const registeredList = resultData.filter(function (elem) {
            return elem.trJuchuKihonId > 0
          })
          self.searchResultList = Object.assign([], registeredList)
          resultData.map((elem, index) => {
            // スプレッドシート用にここで編集
            elem.rowNo = index + 1
            elem.errFlg = false
            elem.editMode = false
            // 取得したレコードはすべて変更扱いとする（登録時に全件送るため）
            elem.editFlg = true
            elem.initializeInputValueSetFlg = true

            // ここから表示用編集
            elem.jinin1ShukkinYoteiHms = ![undefined, null, ''].includes(elem.jinin1ShukkinYoteiHms) ? (elem.jinin1ShukkinYoteiHms).slice(0, 5) : ''
            elem.sagyoYoteiYmd = ![undefined, null, ''].includes(elem.sagyoYoteiYmd) ? filter.dateFormatter(elem.sagyoYoteiYmd) : filter.dateFormatter(elem.seikyuYoteiYmd)
            elem.sagyoYoteiStartYmd = ![undefined, null, ''].includes(elem.sagyoYoteiStartYmd) ? filter.dateFormatter(elem.sagyoYoteiStartYmd) : ''
            elem.sagyoYoteiEndYmd = ![undefined, null, ''].includes(elem.sagyoYoteiEndYmd) ? filter.dateFormatter(elem.sagyoYoteiEndYmd) : ''
            elem.jinin1ShukkinYoteiYmd = ![undefined, null, ''].includes(elem.jinin1ShukkinYoteiYmd) ? filter.dateFormatter(elem.jinin1ShukkinYoteiYmd) : ''
            elem.jinin2ShukkinYoteiYmd = ![undefined, null, ''].includes(elem.jinin2ShukkinYoteiYmd) ? filter.dateFormatter(elem.jinin2ShukkinYoteiYmd) : ''
            elem.juchuYmd = ![undefined, null, ''].includes(elem.juchuYmd) ? filter.dateFormatter(elem.juchuYmd) : ''
            elem.motoukeHokokuYmd = ![undefined, null, ''].includes(elem.motoukeHokokuYmd) ? filter.dateFormatter(elem.motoukeHokokuYmd) : ''
            elem.nyukinYoteiYmd = ![undefined, null, ''].includes(elem.nyukinYoteiYmd) ? filter.dateFormatter(elem.nyukinYoteiYmd) : ''
            elem.shukaYmd = ![undefined, null, ''].includes(elem.shukaYmd) ? filter.dateFormatter(elem.shukaYmd) : ''
            elem.hacchusakiHikiukeYmd = ![undefined, null, ''].includes(elem.hacchusakiHikiukeYmd) ? filter.dateFormatter(elem.hacchusakiHikiukeYmd) : ''
            elem.hatsuchiYmd = ![undefined, null, ''].includes(elem.hatsuchiYmd) ? filter.dateFormatter(elem.hatsuchiYmd) : ''
            elem.hatsuchiHms = ![undefined, null, ''].includes(elem.hatsuchiHms) ? (elem.hatsuchiHms).slice(0, 5) : ''
            elem.chakuchiYmd = ![undefined, null, ''].includes(elem.chakuchiYmd) ? filter.dateFormatter(elem.chakuchiYmd) : ''
            elem.chakuchiHms = ![undefined, null, ''].includes(elem.chakuchiHms) ? (elem.chakuchiHms).slice(0, 5) : ''
            elem.seikyuYoteiYmd = ![undefined, null, ''].includes(elem.seikyuYoteiYmd) ? filter.dateFormatter(elem.seikyuYoteiYmd) : ''
            elem.shiharaiYoteiYmd = ![undefined, null, ''].includes(elem.shiharaiYoteiYmd) ? filter.dateFormatter(elem.shiharaiYoteiYmd) : ''
            elem.unchinCheckYmd = ![undefined, null, ''].includes(elem.unchinCheckYmd) ? filter.dateFormatter(elem.unchinCheckYmd) : ''
            elem.uketsukeYmd = ![undefined, null, ''].includes(elem.uketsukeYmd) ? filter.dateFormatter(elem.uketsukeYmd) : ''

            // 請求金額・支払金額関数埋め込み
            const y = index + 1
            elem.seikyuKingakuGokeiFormula = ![undefined, null, ''].includes(self.seikyuKingakuGokeiFormula) ? '=' + self.seikyuKingakuGokeiFormula.replaceAll('{rowNo}', `${y}`) : ''
            elem.shiharaiKingakuGokeiFormula = ![undefined, null, ''].includes(self.shiharaiKingakuGokeiFormula) ? '=' + self.shiharaiKingakuGokeiFormula.replaceAll('{rowNo}', `${y}`) : ''

            return elem
          })
          self.rows = resultData

          self.isConditionHide = true
          self.isAfterSearch = true

          self.$nextTick(() => {
            var maxRows = self.$refs.ddSpreadSheet.options.pagination ?? 25
            for (let n = self.rows.length; n < Number(maxRows); n++) {
              self.rowAppend(null, false)
            }
            const fixedHeaderColumns = self.headers.filter(x => x.fixedHeader).length
            self.$refs.ddSpreadSheet.setFreezeColumns(fixedHeaderColumns > 0 ? fixedHeaderColumns : 1)
          })
        },
        isNoMessageModeMethod: function () {
          return noMessage
        },
        getSavedInputMethod: function () {
          return {}
        },
        failureValidateMethod: function () {
          self.torikomiConditonsRequired = true
          self.tableRowRequired = true
        }
      }
      this.$nextTick(() => {
        this.search(opt)
      })
    },
    // 検索前チェック
    searchValidate: function () {
      return true
    },

    // 登録前チェック
    registerValidate: function () {
      const self = this
      /*
      const filledRows = this.rows
        .map((row, rowIndex) => ({ row, rowIndex }))
        .filter(({ row }) =>
          Object.values(row).some(value => value !== null && value !== '')
        )
      */
      const filledRows = this.rows.filter(function (elem) {
        return elem.editFlg === true && elem.errFlg !== true
      })

      let noProblem = true

      filledRows.forEach((row, rowIndex) => {
        self.headers.forEach((col, colIndex) => {
          if (col.isRequired) {
            const cellValue = row[col.name]
            const isEmpty = cellValue === null || cellValue === ''
            const cellName = self.$refs.ddSpreadSheet.getCellNameFromCoords(colIndex, rowIndex)

            if (isEmpty) {
              noProblem = false
              // 見た目にわかるよう赤背景をつける
              self.$refs.ddSpreadSheet.jspreadsheetObj.setStyle(cellName, 'background-color', '#ffcccc')
            } else {
              // 問題なければ背景を戻す（任意）
              self.$refs.ddSpreadSheet.jspreadsheetObj.setStyle(cellName, 'background-color', '')
            }
          }
        })
      })

      return noProblem
    },

    /**
     * 一覧ヘッダ作成
     */
    setHeader: async function () {
      const self = this
      return new Promise(resolve => {
        // 現在日付取得
        const target = filter.dateFormatter(new Date())

        // 営業所コード取得
        const me = indexeddb.getRecord(self.eigyoshoList, self.conditions.haishaEigyoshoId)

        // --------------------------------------------------------------------------------
        // スプレッド用ドロップダウン作成
        // --------------------------------------------------------------------------------
        // 営業所
        var wkEigyoshoList = ['未選択']
        const mEigyoshoLisst = self.eigyoshoList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter(function (elem) {
          return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03'
        })
        const tEigyoshoList = mEigyoshoLisst.map(elem => {
          return elem.eigyoshoNm
        })
        wkEigyoshoList = wkEigyoshoList.concat(tEigyoshoList)

        // 配車先
        var wkHaishasakiList = ['自社', '傭車']

        // 乗務員
        var wkJomuinList = ['未選択']
        const mJomuinList = self.eigyoshoJininList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter(function (elem) {
          return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && ([undefined, null].includes(me) || elem.eigyoshoCd === me.eigyoshoCd) && elem.jomuFlg === true
        })
        const tJomuinList = mJomuinList.map(elem => {
          return elem.jininNmSei
        })
        wkJomuinList = wkJomuinList.concat(tJomuinList)

        // 車両（全部）
        var wkSharyoList = ['未選択']
        const mSharyoList = self.sharyoList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter(function (elem) {
          return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
        })
        const tSharyoList = mSharyoList.map(elem => {
          return elem.jidoshaHyojiNm
        })
        wkSharyoList = wkSharyoList.concat(tSharyoList)

        // 車両（自社）
        var wkSharyoJishaList = ['未選択'].concat(mSharyoList.filter(function (elem) {
          return elem.hacchusakiFlg !== true
        }).map(elem => {
          return elem.jidoshaHyojiNm
        }))

        // 車両（傭車）
        var wkSharyoYoshaList = ['未選択'].concat(mSharyoList.filter(function (elem) {
          return elem.hacchusakiFlg === true
        }).map(elem => {
          return elem.jidoshaHyojiNm
        }))

        // 傭車先
        var wkYoshasakiList = ['未選択']
        const mYoshasakiList = self.torihikisakiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hacchusakiFlg === true
        })
        const tYoshasakiList = mYoshasakiList.map(elem => {
          return elem.torihikisakiNm
        })
        wkYoshasakiList = wkYoshasakiList.concat(tYoshasakiList)

        // 得意先
        var wkTokuisakiList = ['未選択']
        const mTokuisakiList = self.torihikisakiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
        })
        const tTokuisakiList = mTokuisakiList.map(elem => {
          return elem.torihikisakiNm
        })
        wkTokuisakiList = wkTokuisakiList.concat(tTokuisakiList)

        // 荷受人
        var wkNiukeninList = ['未選択']
        const mNiukeninList = self.torihikisakiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
        })
        const tNiukeninList = mNiukeninList.map(elem => {
          return elem.torihikisakiNm
        })
        wkNiukeninList = wkNiukeninList.concat(tNiukeninList)

        // 発着地
        var wkHacchakuchiList = ['未選択']
        const mHacchakuchiList = self.hacchakuchiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
        })
        const tHacchakuchiList = mHacchakuchiList.map(elem => {
          return elem.hacchakuchiNm
        })
        wkHacchakuchiList = wkHacchakuchiList.concat(tHacchakuchiList)

        // 発地
        var wkHatsuchiList = ['未選択']
        const mHatsuchiList = self.hacchakuchiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hatsuchiFlg
        })
        const tHatsuchiList = mHatsuchiList.map(elem => {
          return elem.HatsuchiNm
        })
        wkHatsuchiList = wkHatsuchiList.concat(tHatsuchiList)

        // 経由地
        var wkKeiyuchiList = ['未選択']
        const mKeiyuchiList = self.hacchakuchiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.keiyuchiFlg
        })
        const tKeiyuchiList = mKeiyuchiList.map(elem => {
          return elem.KeiyuchiNm
        })
        wkKeiyuchiList = wkKeiyuchiList.concat(tKeiyuchiList)

        // 着地
        var wkChakuchiList = ['未選択']
        const mChakuchiList = self.hacchakuchiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.chakuchiFlg
        })
        const tChakuchiList = mChakuchiList.map(elem => {
          return elem.ChakuchiNm
        })
        wkChakuchiList = wkChakuchiList.concat(tChakuchiList)

        // 商品
        var wkShohinList = ['未選択']
        const mShohinList = self.hinmeiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
        })
        const tShohinList = mShohinList.map(elem => {
          return elem.hinmeiNm
        })
        wkShohinList = wkShohinList.concat(tShohinList)

        // 品目種別
        var wkHinmokuShubetsuList = ['未選択']
        const mHinmokuShubetsuList = self.shubetsuList.filter((elem) => {
          return elem.sbtShuruiCd === 'GVIJ02' && elem.kaishaCd === self.currentKaishaCode
        })
        const tHinmokuShubetsuList = mHinmokuShubetsuList.map(elem => {
          return elem.sbtNm
        })
        wkHinmokuShubetsuList = wkHinmokuShubetsuList.concat(tHinmokuShubetsuList)

        // 単位
        var wkTaniShubetsuList = ['未選択']
        const mTaniShubetsuList = self.shubetsuList.filter((elem) => {
          return elem.sbtShuruiCd === 'SVI001' && elem.kaishaCd === self.currentKaishaCode
        })
        const tTaniShubetsuList = mTaniShubetsuList.map(elem => {
          return elem.sbtNm
        })
        wkTaniShubetsuList = wkTaniShubetsuList.concat(tTaniShubetsuList)

        // 運賃計算区分
        var wkUnchinKeisanKubunList = ['未選択']
        const mUnchinKeisanKubunList = self.kubunList.filter((elem) => {
          return elem.kbnShuruiCd === 'SFF055' && elem.kaishaCd === self.currentKaishaCode && ['01', '02', '03'].includes(elem.code)
        })
        const tUnchinKeisanKubunList = mUnchinKeisanKubunList.map(elem => {
          return elem.codeNm
        })
        wkUnchinKeisanKubunList = wkUnchinKeisanKubunList.concat(tUnchinKeisanKubunList)

        // 請求車種
        var wkShashuList = ['未選択']
        const mShashuList = self.shubetsuList.filter((elem) => {
          return elem.sbtShuruiCd === 'GVI011' && elem.kaishaCd === self.currentKaishaCode
        })
        const tShashuList = mShashuList.map(elem => {
          return elem.sbtNm
        })
        wkShashuList = wkShashuList.concat(tShashuList)

        // 荷姿種別
        var wkNisugataList = ['未選択']
        const mNisugataList = self.shubetsuList.filter((elem) => {
          return elem.sbtShuruiCd === 'SBT019' && elem.kaishaCd === self.currentKaishaCode
        })
        const tNisugataList = mNisugataList.map(elem => {
          return elem.sbtNm
        })
        wkNisugataList = wkNisugataList.concat(tNisugataList)

        // 支払方法
        var wkShiharaiHohoList = ['未選択']
        const mShiharaiHohoList = self.shubetsuList.filter((elem) => {
          return elem.sbtShuruiCd === 'SBT021' && elem.kaishaCd === self.currentKaishaCode
        })
        const tShiharaiHohoList = mShiharaiHohoList.map(elem => {
          return elem.sbtNm
        })
        wkShiharaiHohoList = wkShiharaiHohoList.concat(tShiharaiHohoList)

        // 連絡方法
        var wkRenrakuHohoList = ['未選択']
        const mRenrakuHohoList = self.shubetsuList.filter((elem) => {
          return elem.sbtShuruiCd === 'SBT062' && elem.kaishaCd === self.currentKaishaCode
        })
        const tRenrakuHohoList = mRenrakuHohoList.map(elem => {
          return elem.sbtNm
        })
        wkRenrakuHohoList = wkRenrakuHohoList.concat(tRenrakuHohoList)

        // 運送扱い
        var wkUnsoAtsukaiList = ['未選択']
        const mUnsoAtsukaiList = self.shubetsuList.filter((elem) => {
          return elem.sbtShuruiCd === 'SBT064' && elem.kaishaCd === self.currentKaishaCode
        })
        const tUnsoAtsukaiList = mUnsoAtsukaiList.map(elem => {
          return elem.sbtNm
        })
        wkUnsoAtsukaiList = wkUnsoAtsukaiList.concat(tUnsoAtsukaiList)

        // 入金方法
        var wkNyukinKubunList = ['未選択']
        const mNyukinKubunList = self.kubunList.filter((elem) => {
          return elem.kbnShuruiCd === 'SFF061' && elem.kaishaCd === self.currentKaishaCode
        })
        const tNyukinKubunList = mNyukinKubunList.map(elem => {
          return elem.codeNm
        })
        wkNyukinKubunList = wkNyukinKubunList.concat(tNyukinKubunList)

        // 往復種別
        var wkOhfukuSbtList = ['未選択']
        const mOhfukuSbtList = self.shubetsuList.filter((elem) => {
          return elem.sbtShuruiCd === 'SBT006' && elem.kaishaCd === self.currentKaishaCode
        })
        const tOhfukuSbtList = mOhfukuSbtList.map(elem => {
          return elem.sbtNm
        })
        wkOhfukuSbtList = wkOhfukuSbtList.concat(tOhfukuSbtList)

        // 品質種別
        var wkHinsitsuSbtList = ['未選択']
        const mHinsitsuSbtList = self.shubetsuList.filter((elem) => {
          return elem.sbtShuruiCd === 'SBT006' && elem.kaishaCd === self.currentKaishaCode
        })
        const tHinsitsuSbtList = mHinsitsuSbtList.map(elem => {
          return elem.sbtNm
        })
        wkHinsitsuSbtList = wkHinsitsuSbtList.concat(tHinsitsuSbtList)

        // 定型コース
        var wkTeikeiCourseList = ['未選択']
        const mTeikeiCourseList = self.teikeiCourseList.filter(function (elem) {
          return (self.eigyoshoLockFlg || elem.tantoEigyoshoCd === self.usersEigyoshoCd || [undefined, null, ''].includes(elem.tantoEigyoshoCd))
        })
        const tTeikeiCourseList = mTeikeiCourseList.map(elem => {
          return elem.teikeiCourseNm
        })
        wkTeikeiCourseList = wkTeikeiCourseList.concat(tTeikeiCourseList)
        // --------------------------------------------------------------------------------
        // スプレッド用ヘッダ作成
        // --------------------------------------------------------------------------------
        if (![undefined, null, []].includes(self.headers) && self.headers.length > 0) { return resolve() }

        self.headers = []

        // マスタ情報から自動生成
        self.xlsImportMappingList.filter(function (elem) {
          return elem.formatCd === self.conditions.layoutType && elem.hyojiFlg === true
        }).sort((a, b) => {
          if (a.columnNo - b.columnNo !== 0) { return a.columnNo - b.columnNo }
          return -1
        }).forEach((elem) => {
          var dropdownList = null
          if (elem.source === 'EigyoshoList') {
            dropdownList = wkEigyoshoList
          } else if (elem.source === 'HaishasakiKbnList') {
            dropdownList = wkHaishasakiList
          } else if (elem.source === 'YoshasakiList') {
            dropdownList = wkYoshasakiList
          } else if (elem.source === 'JininList') {
            dropdownList = wkJomuinList
          } else if (elem.source === 'SharyoList') {
            dropdownList = wkSharyoList
          } else if (elem.source === 'SharyoJishaList') {
            dropdownList = wkSharyoJishaList
          } else if (elem.source === 'SharyoYoshaList') {
            dropdownList = wkSharyoYoshaList
          } else if (elem.source === 'TokuisakiList') {
            dropdownList = wkTokuisakiList
          } else if (elem.source === 'NiukeninList') {
            dropdownList = wkNiukeninList
          } else if (elem.source === 'HacchakuchiList') {
            dropdownList = wkHacchakuchiList
          } else if (elem.source === 'HatsuchiList') {
            dropdownList = wkHatsuchiList
          } else if (elem.source === 'KeiyuchiList') {
            dropdownList = wkKeiyuchiList
          } else if (elem.source === 'ChakuchiList') {
            dropdownList = wkChakuchiList
          } else if (elem.source === 'ShohinList') {
            dropdownList = wkShohinList
          } else if (elem.source === 'HinmokuShubetsuList') {
            dropdownList = wkHinmokuShubetsuList
          } else if (elem.source === 'TaniSbtList') {
            dropdownList = wkTaniShubetsuList
          } else if (elem.source === 'UnchinKeisanKbnList') {
            dropdownList = wkUnchinKeisanKubunList
          } else if (elem.source === 'ShashuSbtList') {
            dropdownList = wkShashuList
          } else if (elem.source === 'NisugataList') {
            dropdownList = wkNisugataList
          } else if (elem.source === 'ShiharaiHohoList') {
            dropdownList = wkShiharaiHohoList
          } else if (elem.source === 'RenrakuHohoList') {
            dropdownList = wkRenrakuHohoList
          } else if (elem.source === 'UnsoAtsukaiList') {
            dropdownList = wkUnsoAtsukaiList
          } else if (elem.source === 'NyukinKubunList') {
            dropdownList = wkNyukinKubunList
          } else if (elem.source === 'OhfukuSbtList') {
            dropdownList = wkOhfukuSbtList
          } else if (elem.source === 'HinsitsuSbtList') {
            dropdownList = wkHinsitsuSbtList
          } else if (elem.source === 'TeikeiCourseList') {
            dropdownList = wkTeikeiCourseList
          }

          // 請求金額計算用定義
          if (elem.bindItemNm === 'seikyuKingakuGokeiFormula') {
            self.seikyuKingakuGokeiFormula = elem.formulaStrings
          } else if (elem.bindItemNm === 'shiharaiKingakuGokeiFormula') {
            self.shiharaiKingakuGokeiFormula = elem.formulaStrings
          }

          // display_formatが設定されている日付項目は表示のみdisplay_formatで上書きする
          // (type/customInputは変更しない。編集UIやバリデーションは従来通りYYYY/MM/DD)
          // ※ display_format は日付(date/customDate)以外の input_type(numeric/text等)にも
          //   将来的に設定され得る汎用カラムだが、date以外への適用は本対応では未実装。
          //   date以外で表示フォーマットを効かせたい場合は、DdSpreadSheet.vue側に
          //   type別のフォーマット適用処理(例: numericならformula/mask相当の表示上書き、
          //   textなら任意の整形関数)を追加し、ここで elem.inputType に応じて
          //   customXxxFormat相当のプロパティをheaderへ渡すよう拡張すること。
          const isDateColumn = ['date', 'customDate'].includes(elem.inputType)
          const useCustomDateFormat = isDateColumn && !!elem.displayFormat

          // ヘッダー作成
          self.headers.push({
            title: elem.columnNm,
            name: elem.bindItemNm,
            type: elem.standardInputFlg !== true ? null : elem.inputType,
            customInput: elem.standardInputFlg === true ? null : elem.inputType,
            customDateFormat: useCustomDateFormat ? elem.displayFormat : undefined,
            validateType: elem.validateType,
            required: false,
            isRequired: elem.requiredFlg,
            readOnly: elem.readonlyFlg,
            autocomplete: elem.autocompleteFlg,
            width: elem.width + 'px',
            source: dropdownList,
            align: elem.align,
            mask: elem.inputSuffix,
            validateIntDigit: elem.inputIntDigit,
            validateDecimalDigit: elem.inputDecimalDigit,
            // headerStyle: elem.headerStyle === null ? undefined : elem.headerStyle,
            tooltip: elem.requiredFlg ? '必須項目' : undefined,
            columnNo: elem.columnNo,
            fixedHeader: elem.fixedHeaderFlg,
            initializeInputValue: elem.initializeInputValue
          })
        })
        resolve()
      })
    },

    /**
     * 品名ドロップダウン設定
     */
    setHinmeiCellSettings: function (colIndex, rowIndex, column) {
      const self = this
      // 現在日付取得
      const target = filter.dateFormatter(new Date())

      // 品目種別返還
      const m = self.shubetsuList.filter(function (item) {
        return item.kaishaCd === self.currentKaishaCode && item.sbtShuruiCd === 'GVIJ02' && item.sbtNm === self.rows[rowIndex].hinmokuSbtNm
      })
      const hinshuSbt = m.length > 0 ? m[0].sbtCd : null

      // 商品
      var wkShohinList = ['未選択']
      const mShohinList = this.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && ([undefined, null, '', hinshuSbt].includes(t.hinshuSbt) || hinshuSbt === null)
      })
      const tShohinList = mShohinList.map(elem => {
        return elem.hinmeiNm
      })
      wkShohinList = wkShohinList.concat(tShohinList)

      // 品名セルの設定
      this.$refs.ddSpreadSheet.jspreadsheetObj.setProperty(this.computedColNumList.hinmeiNm, rowIndex, {
        ...column,
        type: 'dropdown',
        autocomplete: true,
        source: wkShohinList
      })
    },
    // セル変更時
    onSetCustomCell: function (cell, x, y, value, row, column) {
      if (this.computedColNumList.hinmokuSbtNm === Number(x)) {
        const targetColumn = this.headers.find(item => item.name === 'hinmeiNm')
        this.setHinmeiCellSettings(Number(x), y, targetColumn)
      }
    },

    /**
     * 読み取り専用設定
     */
    setReadonlyCell: function (rowData, columnName) {
      if (this.isShoukaiMode) {
        return true
      }
      // 行に 請求済み フラグが立っていたら
      if (rowData && rowData.seikyuZumiFlg) {
        if ([
          'juchuYmd',
          'chumonNo',
          'juchuEigyoshoNm',
          'juchuBumonNm',
          'tokuisakiNm',
          'tokuisakiTelNo',
          'tokuisakiEmail',
          'tokuisakiTantosha',
          'maninushiNm',
          'juchuUkeoiKaiso',
          'uketsukeYmd',
          'unsoHokenKanyuItakuFlg',
          'unsoAtsukaiSbtNm',
          'juchuSharyoSuryo',
          'nyukinYoteiYmd',
          'shukaYmd',
          'niukeninNm',
          'niukeninBiko',
          'seikyuYoteiYmd',
          'seikyuTomeFlg',
          'unchinKakuteiFlg',
          'seikyuZumiFlg',
          'seikyuShashuSbtNm',
          'nisugataSbtNm',
          'unchinKeisanKbnNm',
          'hatsuchiNm',
          'hatsuchiBiko',
          'hatsuchiYmd',
          'hatsuchiHms',
          'hatsuchiHmsBiko',
          'keiyuchiNm1',
          'keiyuchiId1Biko',
          'keiyuchiNm2',
          'keiyuchiId2Biko',
          'keiyuchiNm3',
          'keiyuchiId3Biko',
          'keiyuchiNm4',
          'keiyuchiId4Biko',
          'keiyuchiNm5',
          'keiyuchiId5Biko',
          'chakuchiNm',
          'chakuchiBiko',
          'chakuchiYmd',
          'chakuchiHms',
          'chakuchiHmsBiko',
          'oroshisakiNm',
          'shashiNo',
          'kontenaNo',
          'ohfukuSbtNm',
          'yoteiSagyoJikan',
          'warimashiTaishoJikan',
          'warimashiJikanTanka',
          'yoteiSokoKyori',
          'warimashiTaishoKyori',
          'warimashiKyoriTanka',
          'taikiJikanTanka',
          'taikiJikan',
          'teikeiCourseNm',
          'jishaDenpyoNo',
          'okurijoNo',
          'oyaDenpyoNo',
          'denpyoSbt',
          'unchinCheckYmd',
          'shujitsuFlg',
          'startLockFlg',
          'endLockFlg',
          'niukeninTelNo',
          'niukeninFaxNo',
          'niukeninJusho',
          'niukeninMailAddress',
          'niukeninTantoshaNm',
          'tsumikomiUmuFlg',
          'tsumikomiSagyoJikan',
          'torioroshiUmuFlg',
          'torioroshiSagyoJikan',
          'futaiGyomuBiko',
          'hinmokuSbtNm',
          'hinmeiNm',
          'hinmeiBiko',
          'juchuSuryo',
          'juchuBaraSuryo',
          'unitKbnNm',
          'juchuJuryo',
          'gaisanJuryo',
          'juchuSaisu',
          'tanka',
          'width',
          'depth',
          'height',
          'hinsitsuSbtNm',
          'nisugataBiko',
          'meisaiKihonUnchin',
          'meisaiJikanWarimashiKingaku',
          'meisaiKyoriWarimashiKingaku',
          'meisaiKeisuWarimashiKingaku',
          'meisaiNenryoWarimashiKingaku',
          'meisaiHiwayPrice',
          'meisaiNenryoSurcharge',
          'meisaiTsumikomiKingaku',
          'meisaiTorioroshiKingaku',
          'meisaiTaikiJikanKingaku',
          'meisaiFutaiGyomuKingaku',
          'meisaiFutaiGyomuKingaku1',
          'meisaiFutaiGyomuKingaku2',
          'meisaiFutaiGyomuKingaku3',
          'meisaiFutaiGyomuKingaku4',
          'meisaiFutaiGyomuKingaku5',
          'meisaiFutaiGyomuKingaku6',
          'meisaiFutaiGyomuKingaku7',
          'meisaiFutaiGyomuKingaku8',
          'meisaiFutaiGyomuKingaku9',
          'meisaiFutaiGyomuKingaku10',
          'meisaiUserKingakuKazei1',
          'meisaiUserKingakuKazei2',
          'meisaiUserKingakuKazei3',
          'meisaiUserKingakuKazei4',
          'meisaiUserKingakuKazei5',
          'meisaiUserKingakuKazei6',
          'meisaiUserKingakuKazei7',
          'meisaiUserKingakuKazei8',
          'meisaiUserKingakuKazei9',
          'meisaiUserKingakuKazei10',
          'meisaiUserKingakuHikazei1',
          'meisaiUserKingakuHikazei2',
          'meisaiUserKingakuHikazei3',
          'meisaiUserKingakuHikazei4',
          'meisaiUserKingakuHikazei5',
          'meisaiUserKingakuHikazei6',
          'meisaiUserKingakuHikazei7',
          'meisaiUserKingakuHikazei8',
          'meisaiUserKingakuHikazei9',
          'meisaiUserKingakuHikazei10',
          'meisaiUserKingakuUchizei1',
          'meisaiUserKingakuUchizei2',
          'meisaiUserKingakuUchizei3',
          'meisaiUserKingakuUchizei4',
          'meisaiUserKingakuUchizei5',
          'meisaiUserKingakuUchizei6',
          'meisaiUserKingakuUchizei7',
          'meisaiUserKingakuUchizei8',
          'meisaiUserKingakuUchizei9',
          'meisaiUserKingakuUchizei10',
          'meisaiHanyoKingaku1',
          'meisaiHanyoKingaku2',
          'meisaiHanyoKingaku3',
          'meisaiHanyoKingaku4',
          'meisaiHanyoKingaku5',
          'meisaiHanyoKingakuZeiKbn1',
          'meisaiHanyoKingakuZeiKbn2',
          'meisaiHanyoKingakuZeiKbn3',
          'meisaiHanyoKingakuZeiKbn4',
          'meisaiHanyoKingakuZeiKbn5',
          'hinmokuKihonUnchin',
          'hinmokuJikanWarimashiKingaku',
          'hinmokuKyoriWarimashiKingaku',
          'hinmokuKeisuWarimashiKingaku',
          'hinmokuNenryoWarimashiKingaku',
          'hinmokuHiwayPrice',
          'hinmokuNenryoSurcharge',
          'hinmokuTsumikomiKingaku',
          'hinmokuTorioroshiKingaku',
          'hinmokuTaikiJikanKingaku',
          'hinmokuFutaiGyomuKingaku',
          'hinmokuFutaiGyomuKingaku1',
          'hinmokuFutaiGyomuKingaku2',
          'hinmokuFutaiGyomuKingaku3',
          'hinmokuFutaiGyomuKingaku4',
          'hinmokuFutaiGyomuKingaku5',
          'hinmokuFutaiGyomuKingaku6',
          'hinmokuFutaiGyomuKingaku7',
          'hinmokuFutaiGyomuKingaku8',
          'hinmokuFutaiGyomuKingaku9',
          'hinmokuFutaiGyomuKingaku10',
          'hinmokuUserKingakuKazei1',
          'hinmokuUserKingakuKazei2',
          'hinmokuUserKingakuKazei3',
          'hinmokuUserKingakuKazei4',
          'hinmokuUserKingakuKazei5',
          'hinmokuUserKingakuKazei6',
          'hinmokuUserKingakuKazei7',
          'hinmokuUserKingakuKazei8',
          'hinmokuUserKingakuKazei9',
          'hinmokuUserKingakuKazei10',
          'hinmokuUserKingakuHikazei1',
          'hinmokuUserKingakuHikazei2',
          'hinmokuUserKingakuHikazei3',
          'hinmokuUserKingakuHikazei4',
          'hinmokuUserKingakuHikazei5',
          'hinmokuUserKingakuHikazei6',
          'hinmokuUserKingakuHikazei7',
          'hinmokuUserKingakuHikazei8',
          'hinmokuUserKingakuHikazei9',
          'hinmokuUserKingakuHikazei10',
          'hinmokuUserKingakuUchizei1',
          'hinmokuUserKingakuUchizei2',
          'hinmokuUserKingakuUchizei3',
          'hinmokuUserKingakuUchizei4',
          'hinmokuUserKingakuUchizei5',
          'hinmokuUserKingakuUchizei6',
          'hinmokuUserKingakuUchizei7',
          'hinmokuUserKingakuUchizei8',
          'hinmokuUserKingakuUchizei9',
          'hinmokuUserKingakuUchizei10',
          'hinmokuHanyoKingaku1',
          'hinmokuHanyoKingaku2',
          'hinmokuHanyoKingaku3',
          'hinmokuHanyoKingaku4',
          'hinmokuHanyoKingaku5',
          'hinmokuHanyoKingakuZeiKbn1',
          'hinmokuHanyoKingakuZeiKbn2',
          'hinmokuHanyoKingakuZeiKbn3',
          'hinmokuHanyoKingakuZeiKbn4',
          'hinmokuHanyoKingakuZeiKbn5'
        ].includes(columnName)) {
          return true // ← そのセルを読み取り専用に
        }
      }
      // 行に 支払済み フラグが立っていたら
      if (rowData && rowData.shiharaiZumiFlg) {
        if ([
          'jidoshaHyojiNm',
          'hacchusakiFlg',
          'sharyoHacchusakiCd',
          'sharyoHacchusakiNm',
          'juchuYmd',
          'chumonNo',
          'juchuEigyoshoNm',
          'hacchusakiKbnNm',
          'hacchusakiNm',
          'hacchusakiTelNo',
          'hacchusakiEmail',
          'hacchusakiTantosha',
          'hacchushoSendZumiFlg',
          'hacchusakiHikiukeYmd',
          'hacchuSharyoSuryo',
          'shiharaiHohoKbnNm',
          'niukeninNm',
          'niukeninBiko',
          'hatsuchiNm',
          'hatsuchiBiko',
          'hatsuchiYmd',
          'hatsuchiHms',
          'hatsuchiHmsBiko',
          'keiyuchiNm1',
          'keiyuchiId1Biko',
          'keiyuchiNm2',
          'keiyuchiId2Biko',
          'keiyuchiNm3',
          'keiyuchiId3Biko',
          'keiyuchiNm4',
          'keiyuchiId4Biko',
          'keiyuchiNm5',
          'keiyuchiId5Biko',
          'chakuchiNm',
          'chakuchiBiko',
          'chakuchiYmd',
          'chakuchiHms',
          'chakuchiHmsBiko',
          'oroshisakiNm',
          'shashiNo',
          'kontenaNo',
          'ohfukuSbt',
          'ohfukuSbtNm',
          'yoteiSagyoJikan',
          'warimashiTaishoJikan',
          'warimashiJikanTanka',
          'yoteiSokoKyori',
          'warimashiTaishoKyori',
          'warimashiKyoriTanka',
          'taikiJikanTanka',
          'taikiJikan',
          'teikeiCourseNm',
          'jishaDenpyoNo',
          'okurijoNo',
          'oyaDenpyoNo',
          'denpyoSbt',
          'unchinCheckYmd',
          'shujitsuFlg',
          'startLockFlg',
          'endLockFlg',
          'niukeninTelNo',
          'niukeninFaxNo',
          'niukeninJusho',
          'niukeninMailAddress',
          'niukeninTantoshaNm',
          'tsumikomiUmuFlg',
          'tsumikomiSagyoJikan',
          'torioroshiUmuFlg',
          'torioroshiSagyoJikan',
          'futaiGyomuBiko',
          'shiharaiYoteiYmd',
          'shiharaiTomeFlg',
          'shiharaiZumiFlg',
          'hinmokuSbtNm',
          'hinmeiNm',
          'hinmeiBiko',
          'juchuSuryo',
          'juchuBaraSuryo',
          'unitKbnNm',
          'juchuJuryo',
          'gaisanJuryo',
          'juchuSaisu',
          'width',
          'depth',
          'height',
          'hinsitsuSbtNm',
          'nisugataBiko',
          'hacchuTanka',
          'hacchuMeisaiKihonUnchin',
          'hacchuMeisaiJikanWarimashiKingaku',
          'hacchuMeisaiKyoriWarimashiKingaku',
          'hacchuMeisaiKeisuWarimashiKingaku',
          'hacchuMeisaiNenryoWarimashiKingaku',
          'hacchuMeisaiHiwayPrice',
          'hacchuMeisaiNenryoSurcharge',
          'hacchuMeisaiTsumikomiKingaku',
          'hacchuMeisaiTorioroshiKingaku',
          'hacchuMeisaiTaikiJikanKingaku',
          'hacchuMeisaiFutaiGyomuKingaku',
          'hacchuMeisaiFutaiGyomuKingaku1',
          'hacchuMeisaiFutaiGyomuKingaku2',
          'hacchuMeisaiFutaiGyomuKingaku3',
          'hacchuMeisaiFutaiGyomuKingaku4',
          'hacchuMeisaiFutaiGyomuKingaku5',
          'hacchuMeisaiFutaiGyomuKingaku6',
          'hacchuMeisaiFutaiGyomuKingaku7',
          'hacchuMeisaiFutaiGyomuKingaku8',
          'hacchuMeisaiFutaiGyomuKingaku9',
          'hacchuMeisaiFutaiGyomuKingaku10',
          'hacchuMeisaiUserKingakuKazei1',
          'hacchuMeisaiUserKingakuKazei2',
          'hacchuMeisaiUserKingakuKazei3',
          'hacchuMeisaiUserKingakuKazei4',
          'hacchuMeisaiUserKingakuKazei5',
          'hacchuMeisaiUserKingakuKazei6',
          'hacchuMeisaiUserKingakuKazei7',
          'hacchuMeisaiUserKingakuKazei8',
          'hacchuMeisaiUserKingakuKazei9',
          'hacchuMeisaiUserKingakuKazei10',
          'hacchuMeisaiUserKingakuHikazei1',
          'hacchuMeisaiUserKingakuHikazei2',
          'hacchuMeisaiUserKingakuHikazei3',
          'hacchuMeisaiUserKingakuHikazei4',
          'hacchuMeisaiUserKingakuHikazei5',
          'hacchuMeisaiUserKingakuHikazei6',
          'hacchuMeisaiUserKingakuHikazei7',
          'hacchuMeisaiUserKingakuHikazei8',
          'hacchuMeisaiUserKingakuHikazei9',
          'hacchuMeisaiUserKingakuHikazei10',
          'hacchuMeisaiUserKingakuUchizei1',
          'hacchuMeisaiUserKingakuUchizei2',
          'hacchuMeisaiUserKingakuUchizei3',
          'hacchuMeisaiUserKingakuUchizei4',
          'hacchuMeisaiUserKingakuUchizei5',
          'hacchuMeisaiUserKingakuUchizei6',
          'hacchuMeisaiUserKingakuUchizei7',
          'hacchuMeisaiUserKingakuUchizei8',
          'hacchuMeisaiUserKingakuUchizei9',
          'hacchuMeisaiUserKingakuUchizei10',
          'hacchuMeisaiHanyoKingaku1',
          'hacchuMeisaiHanyoKingaku2',
          'hacchuMeisaiHanyoKingaku3',
          'hacchuMeisaiHanyoKingaku4',
          'hacchuMeisaiHanyoKingaku5',
          'hacchuMeisaiHanyoKingakuZeiKbn1',
          'hacchuMeisaiHanyoKingakuZeiKbn2',
          'hacchuMeisaiHanyoKingakuZeiKbn3',
          'hacchuMeisaiHanyoKingakuZeiKbn4',
          'hacchuMeisaiHanyoKingakuZeiKbn5',
          'hacchuHinmokuKihonUnchin',
          'hacchuHinmokuJikanWarimashiKingaku',
          'hacchuHinmokuKyoriWarimashiKingaku',
          'hacchuHinmokuKeisuWarimashiKingaku',
          'hacchuHinmokuNenryoWarimashiKingaku',
          'hacchuHinmokuHiwayPrice',
          'hacchuHinmokuNenryoSurcharge',
          'hacchuHinmokuTsumikomiKingaku',
          'hacchuHinmokuTorioroshiKingaku',
          'hacchuHinmokuTaikiJikanKingaku',
          'hacchuHinmokuFutaiGyomuKingaku',
          'hacchuHinmokuFutaiGyomuKingaku1',
          'hacchuHinmokuFutaiGyomuKingaku2',
          'hacchuHinmokuFutaiGyomuKingaku3',
          'hacchuHinmokuFutaiGyomuKingaku4',
          'hacchuHinmokuFutaiGyomuKingaku5',
          'hacchuHinmokuFutaiGyomuKingaku6',
          'hacchuHinmokuFutaiGyomuKingaku7',
          'hacchuHinmokuFutaiGyomuKingaku8',
          'hacchuHinmokuFutaiGyomuKingaku9',
          'hacchuHinmokuFutaiGyomuKingaku10',
          'hacchuHinmokuUserKingakuKazei1',
          'hacchuHinmokuUserKingakuKazei2',
          'hacchuHinmokuUserKingakuKazei3',
          'hacchuHinmokuUserKingakuKazei4',
          'hacchuHinmokuUserKingakuKazei5',
          'hacchuHinmokuUserKingakuKazei6',
          'hacchuHinmokuUserKingakuKazei7',
          'hacchuHinmokuUserKingakuKazei8',
          'hacchuHinmokuUserKingakuKazei9',
          'hacchuHinmokuUserKingakuKazei10',
          'hacchuHinmokuUserKingakuHikazei1',
          'hacchuHinmokuUserKingakuHikazei2',
          'hacchuHinmokuUserKingakuHikazei3',
          'hacchuHinmokuUserKingakuHikazei4',
          'hacchuHinmokuUserKingakuHikazei5',
          'hacchuHinmokuUserKingakuHikazei6',
          'hacchuHinmokuUserKingakuHikazei7',
          'hacchuHinmokuUserKingakuHikazei8',
          'hacchuHinmokuUserKingakuHikazei9',
          'hacchuHinmokuUserKingakuHikazei10',
          'hacchuHinmokuUserKingakuUchizei1',
          'hacchuHinmokuUserKingakuUchizei2',
          'hacchuHinmokuUserKingakuUchizei3',
          'hacchuHinmokuUserKingakuUchizei4',
          'hacchuHinmokuUserKingakuUchizei5',
          'hacchuHinmokuUserKingakuUchizei6',
          'hacchuHinmokuUserKingakuUchizei7',
          'hacchuHinmokuUserKingakuUchizei8',
          'hacchuHinmokuUserKingakuUchizei9',
          'hacchuHinmokuUserKingakuUchizei10',
          'hacchuHinmokuHanyoKingaku1',
          'hacchuHinmokuHanyoKingaku2',
          'hacchuHinmokuHanyoKingaku3',
          'hacchuHinmokuHanyoKingaku4',
          'hacchuHinmokuHanyoKingaku5',
          'hacchuHinmokuHanyoKingakuZeiKbn1',
          'hacchuHinmokuHanyoKingakuZeiKbn2',
          'hacchuHinmokuHanyoKingakuZeiKbn3',
          'hacchuHinmokuHanyoKingakuZeiKbn4',
          'hacchuHinmokuHanyoKingakuZeiKbn5'
        ].includes(columnName)) {
          return true // ← そのセルを読み取り専用に
        }
      }
      return null
    },
    /**
     * 行制御
     */
    // 行追加 上
    rowAppendAvobe: function (num) {
      this.rowAppend(num, true)
    },
    // 行追加
    rowAppend: function (num, aboveFlg) {
      // 現在の選択セル
      var activeC = this.$refs.ddSpreadSheet.getActiveCell()
      // 行追加先の位置を取得
      var pos = 0
      var posMax = 0
      // 全選択状態なら先頭行に追加
      var isAllSelect = false
      if (!activeC) {
        // セル未選択
      } else if (activeC.length > 3) {
        // セル選択 ※先頭行を基準とする
        pos = Math.min(...[activeC[1], activeC[3]])
        // 複数行制御用に最終行も取得
        posMax = Math.max(...[activeC[1], activeC[3]])

        // 全選択かどうか判定
        var isSame1 = activeC[0] === 0
        var isSame2 = activeC[1] === 0
        var isSame3 = activeC[2] === this.headers.length - 1
        var isSame4 = activeC[3] === this.rows.length - 1
        isAllSelect = isSame1 && isSame2 && isSame3 && isSame4
      }

      const appendCount = posMax - pos + num ? num : 1
      const newrows = Array.from({ length: appendCount }, () => this.setNewRow())

      // 行追加
      if (isAllSelect || (aboveFlg !== undefined && aboveFlg)) {
        if (pos === 0) {
          this.rows.unshift(...newrows)
          pos = 0
        } else {
          this.rows.splice(pos, 0, ...newrows)
        }
      } else {
        if (![undefined, null, 0].includes(pos)) {
          this.rows.splice(pos + 1, 0, ...newrows)
        } else {
          this.rows.splice(this.rows.length, 0, ...newrows)
        }
      }

      // 行番号が狂うので外部からのエラー設定は消去
      this.outsideErrorList = []

      // 行追加後のセルを選択状態にしてあげる…準備
      this.selectTargetPosition = pos + 1

      // 計算式関数見直し
      const self = this
      this.rows.forEach((rec, index) => {
        rec.seikyuKingakuGokeiFormula = ![undefined, null, ''].includes(self.seikyuKingakuGokeiFormula) ? '=' + self.seikyuKingakuGokeiFormula.replaceAll('{rowNo}', `${index + 1}`) : ''
        rec.shiharaiKingakuGokeiFormula = ![undefined, null, ''].includes(self.shiharaiKingakuGokeiFormula) ? '=' + self.shiharaiKingakuGokeiFormula.replaceAll('{rowNo}', `${index + 1}`) : ''
      })

      // 画面への再描写 ※強制発火用にspliceを実行
      // this.rows.splice()
    },
    // 行削除
    rowDelete: function (num, index) {
      console.log('rowDelete : ', num, index, this.rows)

      // 現在の選択セル
      var activeC = this.$refs.ddSpreadSheet.getActiveCell()
      // 行追加先の位置を取得
      var pos = 0
      var posMax = 0
      if (activeC.length > 3) {
        // セル選択 ※先頭行を基準とする
        pos = Math.min(...[activeC[1], activeC[3]])
        // 複数行制御用に最終行も取得
        posMax = Math.max(...[activeC[1], activeC[3]])

        // 削除対象行
        const targetRows = this.rows.slice(pos, posMax + 1)

        // ★ 請求済 or 支払済 の行が含まれていないかチェック
        const hasLockedRow = targetRows.some(row => row.seikyuZumiFlg || row.shiharaiZumiFlg)

        if (hasLockedRow) {
          if (targetRows.some(row => row.seikyuZumiFlg)) {
            this.setInvalidSummaryMessage('RCOI0006')
          }
          if (targetRows.some(row => row.shiharaiZumiFlg)) {
            this.setInvalidSummaryMessage('PLOI0006')
          }
          return // ★ 削除せず終了
        }
        // データを削除
        this.rows.splice(pos, (posMax - pos + 1))
        this.rows = [...this.rows]
        this.$forceUpdate()
      }
    },

    onLoadDataAfter: function () {
      // このタイミングでやるのがまぁ正しいんでしょう
      /*
      if (this.selectTargetPosition !== null) {
        this.$refs.ddSpreadSheet.setActiveCell(0, this.selectTargetPosition)
        this.selectTargetPosition = null
      }
      // 50行作成
      const self = this
      self.$nextTick(function () {
        for (let n = self.rows.length; n < 50; n++) {
          self.rowAppend(null, false)
        }
      })
      */
    },
    setNewRow: function () {
      const userEigyoshoNm = indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyoshoCd, date.getCurrentDate()).eigyoshoNm
      this.newRecordId -= 1
      const baseYmd = this.conditions.sagyoYoteiYmd ?? this.conditions.sagyoYoteiYmdFrom ?? date.getCurrentDate()
      return {
        rowNo: this.rows.length + 1,
        initializeInputValueSetFlg: false,
        // Key♯1
        id: this.newRecordId,
        trSagyoKeikakuMeisaiId: this.newRecordId,
        trSagyoKeikakuSharyoId: this.newRecordId,
        trSagyoKeikakuJininId1: this.newRecordId,
        trSagyoKeikakuJininId2: this.newRecordId,
        // Key#2
        trSagyoMeisaiId: this.newRecordId,
        trSagyoHinmokuId: this.newRecordId,
        trSagyoKingakuId: this.newRecordId,
        trJuchuKihonId: this.newRecordId,
        trJuchuMeisaiId: this.newRecordId,
        trJuchuHinmokuId: this.newRecordId,
        trJuchuKingakuId: this.newRecordId,
        // Key#3 ※2025.08.28 今後のために初期セットしておく
        trUnkoJissekiId: this.newRecordId,
        trSagyoJissekiId: this.newRecordId,
        trKintaiJissekiId1: this.newRecordId,
        trKintaiJissekiId2: this.newRecordId,
        trSharyoKeihiId: this.newRecordId,

        // 計画基本
        sagyoYoteiYmd: null,
        haishaShashuSbt: null,
        eigyoshoId: this.conditions.eigyoshoId,
        // sagyoYoteiStartYmd: null,  ※API側で設定するためここではなにもしない
        // sagyoYoteiEndYmd: null,    ※同上
        // 計画車両
        jidoshaHyojiNm: null,
        unkoSeqNo: null,
        // 計画人員（主）
        jininNm1: null,
        jinin1ShukkinYoteiHms: null,
        // 計画人員（副）
        jininNm2: null,

        // 受注
        sagyoKaiji: null,
        sagyoKaijiJunban: null,
        sagyoOrder: null,
        juchuYmd: baseYmd,
        chmonNo: null,
        juchuMeisaiNo: 1,
        juchuEigyoshoId: this.conditions.eigyoshoId,
        juchuEigyoshoNm: userEigyoshoNm,
        tokuisakiNm: null,
        niukeninNm: null,
        hatsuchiNm: null,
        hatsuchiYmd: null,
        hatsuchiHms: null,
        hatsuchiHmsBiko: null,
        hatsuchiBiko: null,
        keiyuchiId1: null,
        keiyuchiId1Biko: null,
        keiyuchiId2: null,
        keiyuchiId2Biko: null,
        keiyuchiId3: null,
        keiyuchiId3Biko: null,
        keiyuchiId4: null,
        keiyuchiId4Biko: null,
        keiyuchiId5: null,
        keiyuchiId5Biko: null,
        chakuchiNm: null,
        chakuchiYmd: null,
        chakuchiHms: null,
        chakuchiHmsBiko: null,
        chakuchiBiko: null,
        haishaBiko: null,
        renrakuBiko: null,
        denpyoBiko1: null,
        denpyoBiko2: null,
        denpyoBiko3: null,
        denpyoBiko4: null,
        denpyoBiko5: null,
        denpyoBiko6: null,
        denpyoBiko7: null,
        denpyoBiko8: null,
        denpyoBiko9: null,
        denpyoBiko10: null,
        hinshuSbtNm: null,
        hinmeiNm: null,
        juchuSuryo: null,
        unitKbnNm: null,
        juchuJuryo: null,
        tanka: null,
        seikyuYoteiYmd: null,
        unchinKeisanKbnNm: null,
        seikyuShashuSbtNm: null,
        kihonUnchin: null,
        hiwayPrice: null,
        unchinHokaKingaku: null,
        unchinHokaHikazei: null,
        jikanWarimashiKingaku: null,
        kyoriWarimashiKingaku: null,
        warimashiSonotaKingsku: null,
        seikyuKingakuGokei: null,
        seikyuBiko: null,
        shiharaiYoteiYmd: null,
        yoshaKihonUnchin: null,
        yoshaHiwayPrice: null,
        yoshaUnchinHokaKingaku: null,
        yoshaUnchinHokaHikazei: null,
        shiharaiKingakuGokei: null
      }
    },

    /**
     * スプレッドシート変更後イベント
     * @param {*} rowData
     * @param {*} cell
     * @param {*} x
     * @param {*} y
     * @param {*} newValue
     * @param {*} oldValue
     */
    changeAfter (rowData, cell, x, y, newValue, oldValue) {
      // console.log('c', rowData, cell, x, y, newValue, oldValue)
      if (rowData && rowData.initializeInputValueSetFlg !== true) {
        this.setInitializeInputValueIfBlank(y)
        rowData.initializeInputValueSetFlg = true
      }

      if (Number(x) === this.computedColNumList.haishaKbnNm) {
        console.log('change After :', this.computedColNumList.jidoshaHyojiNm, this.computedColNumList.hacchusakiNm)
        // 配車先毎入力制御
        if (newValue === '自社') {
          this.$refs.ddSpreadSheet.setCellReadonly(this.computedColNumList.jidoshaHyojiNm, y, false)
          this.$refs.ddSpreadSheet.setCellReadonly(this.computedColNumList.hacchusakiNm, y, true)
        } else if (newValue === '傭車') {
          this.$refs.ddSpreadSheet.setCellReadonly(this.computedColNumList.jidoshaHyojiNm, y, true)
          this.$refs.ddSpreadSheet.setCellReadonly(this.computedColNumList.hacchusakiNm, y, false)
        }
      }
      // 主たる乗務員をセットする
      if (Number(x) === this.computedColNumList.jidoshaHyojiNm) {
        const target = filter.dateFormatter(new Date())

        const sharyoInfo = this.sharyoList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((elem) => {
          return elem.kaishaCd === this.currentKaishaCode && elem.jidoshaHyojiNm === newValue && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
        })

        if (sharyoInfo.length > 0) {
          const targetJomuinCd = sharyoInfo[0].jomuinCd
          if (![undefined, null, ''].includes(targetJomuinCd)) {
            const targetJomuin = this.eigyoshoJininList.map((elem) => {
              elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
              elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
              return elem
            }).filter((elem) => {
              return elem.kaishaCd === this.currentKaishaCode && elem.jininCd === targetJomuinCd && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
            })
            if (targetJomuin.length > 0) {
              const cell = this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.jininNm1, y)
              this.$refs.ddSpreadSheet.jspreadsheetObj.setValue(cell, targetJomuin[0].jininNmSei, true)
            }
          }
          // 請求車種に車両の車種をセットする
          if (![undefined, null, ''].includes(sharyoInfo[0].shashuSbtNm)) {
            const shashuCell = this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.seikyuShashuSbtNm, y)
            this.$refs.ddSpreadSheet.jspreadsheetObj.setValue(shashuCell, sharyoInfo[0].shashuSbtNm, true)
          }
        }
      }
      // 定型コース情報をセットする
      if (Number(x) === this.computedColNumList.teikeiCourseNm) {
        const self = this
        const m = self.filteredTeikeiCourseList.filter(function (item) {
          return item.teikeiCourseNm?.trim() === newValue
        })
        if (m.length > 0) {
          const mappings = {
            ohfukuSbtNm: 'ohfukuSbtNm',
            chumonNo: 'chumonNo',
            juchuEigyoshoNm: 'tantoEigyoshoNm',
            tokuisakiNm: 'tokuisakiNm',
            hinmeiNm: 'hinmeiNm',
            hinmeiBiko: 'hinmeiBiko',
            hatsuchiNm: 'hatsuchiNm',
            hatsuchiBiko: 'hatsuchiBiko',
            hatsuchiHms: 'hatsuchiHms',
            hatsuchiHmsBiko: 'hatsuchiHmsBiko',
            chakuchiNm: 'chakuchiNm',
            chakuchiBiko: 'chakuchiBiko',
            chakuchiHms: 'chakuchiHms',
            chakuchiHmsBiko: 'chakuchiHmsBiko',
            keiyuchiNm1: 'keiyuchiId1Nm',
            keiyuchiId1Biko: 'keiyuchiId1Biko',
            keiyuchiNm2: 'keiyuchiId2Nm',
            keiyuchiId2Biko: 'keiyuchiId2Biko',
            keiyuchiNm3: 'keiyuchiId3Nm',
            keiyuchiId3Biko: 'keiyuchiId3Biko',
            keiyuchiNm4: 'keiyuchiId4Nm',
            keiyuchiId4Biko: 'keiyuchiId4Biko',
            keiyuchiNm5: 'keiyuchiId5Nm',
            keiyuchiId5Biko: 'keiyuchiId5Biko',
            unchinKeisanKbnNm: 'unchinKeisanKbnNm',
            seikyuShashuSbtNm: 'seikyuShashuSbtNm',
            yoteiSokoKyori: 'yoteiSokoKyori',
            yoteiSagyoJikan: 'yoteiSagyoJikan',
            juchuSuryo: 'juchuSuryo',
            unitKbnNm: 'unitKbnNm',
            juchuJuryo: 'juchuJuryo',
            tanka: 'tanka',
            meisaiKihonUnchin: 'kihonUnchin',
            meisaiHiwayPrice: 'hiwayPrice',
            meisaiUserKingakuKazei1: 'unchinHokaKingaku',
            meisaiUserKingakuKazei4: 'hokanKingaku',
            meisaiUserKingakuKazei3: 'niekiKingaku',
            meisaiUserKingakuHikazei1: 'unchinHokaHikazei',
            meisaiUserKingakuHikazei2: 'tatekaekinHikazei',
            meisaiNenryoSurcharge: 'nenryoSurcharge',
            meisaiTsumikomiKingaku: 'tsumikomiKingaku',
            meisaiTorioroshiKingaku: 'torioroshiKingaku',
            taikiJikan: 'taikiJikan',
            taikiJikanTanka: 'taikiJikanTanka',
            meisaiTaikiJikanKingaku: 'taikiJikanKingaku',
            meisaiFutaiGyomuKingaku: 'futaiGyomuKingaku',
            warimashiTaishoJikan: 'warimashiTaishoJikan',
            warimashiJikanTanka: 'warimashiJikanTanka',
            jikanWarimashiKingaku: 'jikanWarimashiKingaku',
            warimashiTaishoKyori: 'warimashiTaishoKyori',
            warimashiKyoriTanka: 'warimashiKyoriTanka',
            kyoriWarimashiKingaku: 'kyoriWarimashiKingaku',
            meisaiUserKingakuKazei2: 'warimashiSonotaKingaku',
            hacchuMeisaiKihonUnchin: 'yoshaUnchin',
            hacchuMeisaiHiwayPrice: 'yoshaHiwayPrice',
            seikyuBiko: 'seikyuBiko',
            renrakuBiko: 'renrakuBiko',
            hacchuMeisaiUserKingakuKazei1: 'yoshaUnchinHokaKingaku',
            hacchuMeisaiUserKingakuHikazei1: 'yoshaUnchinHokaHikazei',
            shiharaiBiko: 'shiharaiBiko',
            hacchuTanka: 'yoshaTanka',
            denpyoBiko1: 'denpyoBiko1',
            denpyoBiko2: 'denpyoBiko2',
            denpyoBiko3: 'denpyoBiko3',
            denpyoBiko4: 'denpyoBiko4',
            denpyoBiko5: 'denpyoBiko5',
            denpyoBiko6: 'denpyoBiko6',
            denpyoBiko7: 'denpyoBiko7',
            denpyoBiko8: 'denpyoBiko8',
            denpyoBiko9: 'denpyoBiko9',
            denpyoBiko10: 'denpyoBiko10',
            hinmokuSbtNm: 'hinmokuSbtNm'
          }

          Object.entries(mappings).forEach(([columnName, fieldName]) => {
            const cell = this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList[columnName], Number(y))
            this.$refs.ddSpreadSheet.jspreadsheetObj.setValue(cell, m[0][fieldName], true)
          })
        }
      }
      /*
        請求金額自動計算
       */
      if (this.computedColNumList.hinmokuKihonUnchin || this.computedColNumList.meisaiKihonUnchin) {
        const t = this.kubunList.filter((elem) => {
          return elem.kbnShuruiCd === 'SFF055' && elem.kaishaCd === this.currentKaishaCode
        }).find(x => x.codeNm === this.rows[y].unchinKeisanKbnNm)
        const tUnchinKeisanKbn = t ? t.code : '03'
        const hinmoku = this.computedColNumList.hinmokuKihonUnchin ? 'hinmoku' : ''

        if (Number(x) === this.computedColNumList.juchuSuryo && tUnchinKeisanKbn === '01') {
          this.calcKihonUnchinByQuantity(Number(y), hinmoku)
        }
        if (Number(x) === this.computedColNumList.juchuJuryo && tUnchinKeisanKbn === '02') {
          this.calcKihonUnchinByWeight(Number(y), hinmoku)
        }
        if (Number(x) === this.computedColNumList.unchinKeisanKbnNm) {
          if (tUnchinKeisanKbn === '01') {
            this.calcKihonUnchinByQuantity(Number(y), hinmoku)
          } else if (tUnchinKeisanKbn === '02') {
            this.calcKihonUnchinByWeight(Number(y), hinmoku)
          } else {
            this.calcKihonUnchinByCharter(Number(y), hinmoku)
          }
        }
        if (Number(x) === this.computedColNumList.tanka) {
          if (tUnchinKeisanKbn === '01') {
            this.calcKihonUnchinByQuantity(Number(y), hinmoku)
          } else if (tUnchinKeisanKbn === '02') {
            this.calcKihonUnchinByWeight(Number(y), hinmoku)
          } else {
            this.calcKihonUnchinByCharter(Number(y), hinmoku)
          }
        }
      }
    },
    calcKihonUnchinByQuantity: function (y, hinmoku) {
      const rowData = this.$refs.ddSpreadSheet.getRowData(y)
      if (![undefined, null, ''].includes(rowData.juchuSuryo) && ![undefined, null, ''].includes(rowData.tanka)) {
        let cell
        const rowData = this.$refs.ddSpreadSheet.getRowData(y)
        const t = rowData.juchuSuryo * rowData.tanka
        if (![undefined, null, ''].includes(hinmoku)) {
          cell = this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.hinmokuKihonUnchin, y)
        } else {
          cell = this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.meisaiKihonUnchin, y)
        }
        this.$refs.ddSpreadSheet.jspreadsheetObj.setValue(cell, Math.round(t), true)
      }
    },
    calcKihonUnchinByWeight: function (y, hinmoku) {
      const rowData = this.$refs.ddSpreadSheet.getRowData(y)
      if (![undefined, null, ''].includes(rowData.juchuJuryo) && ![undefined, null, ''].includes(rowData.tanka)) {
        let cell
        const t = rowData.juchuSuryo * rowData.tanka
        if (![undefined, null, ''].includes(hinmoku)) {
          cell = this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.hinmokuKihonUnchin, y)
        } else {
          cell = this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.meisaiKihonUnchin, y)
        }
        this.$refs.ddSpreadSheet.jspreadsheetObj.setValue(cell, Math.round(t), true)
      }
    },
    calcKihonUnchinByCharter: function (y, hinmoku) {
      const rowData = this.$refs.ddSpreadSheet.getRowData(y)
      if (![undefined, null, ''].includes(rowData.tanka)) {
        let cell
        if (![undefined, null, ''].includes(hinmoku)) {
          cell = this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.hinmokuKihonUnchin, y)
        } else {
          cell = this.$refs.ddSpreadSheet.getCellNameFromCoords(this.computedColNumList.meisaiKihonUnchin, y)
        }
        this.$refs.ddSpreadSheet.jspreadsheetObj.setValue(cell, Math.round(rowData.tanka), true)
      }
    },
    /**
     * 行追加後イベント
     * @param {} rowNumber
     */
    rowAddAfter (rowNumber) {
      // 背景色設定
      /*
      if (this.rows[rowNumber].id < 0) {
        const self = this
        this.headers.forEach((elem, index) => {
          self.$refs.ddSpreadSheet.setCellClass(index, rowNumber, 'changeCell')
        })
      }
      */
    },

    /**
     * 保存処理（ソースが酷いのでそのうち直す）
     * @returns
     */
    onMultiSaveButtonClick: function () {
      const self = this

      let saveTargetRow = this.rows.filter(function (elem) {
        return elem.editFlg === true && elem.errFlg !== true
      })
      if (saveTargetRow.length < 1) {
        if (self.searchResultList.length < 1) {
          modals.showToast('保存対象がありません', null, 500, null, 'warning')
          return
        } else {
          saveTargetRow = [{ keyGuid: self.searchResultList[0].keyGuid, excludedRow: true }] // ← 1行も編集していない場合はkeyGuidだけ渡してAPIを呼ぶ（API側でkeyGuidを元に削除する）
        }
      }

      // DB保存用変換
      saveTargetRow.map((elem) => {
        // HHMMから秒に変換
        elem.jomuinKosokuJikan = ![null, ''].includes(elem.jomuinKosokuJikanHm) ? filter.timeToMinFormatter(elem.jomuinKosokuJikanHm) : null
        elem.jomuinKyukeiJikan = ![null, ''].includes(elem.jomuinKyukeiJikanHm) ? filter.timeToMinFormatter(elem.jomuinKyukeiJikanHm) : null
        elem.jomuinKadouJikan = ![null, ''].includes(elem.jomuinKadouJikanHm) ? filter.timeToMinFormatter(elem.jomuinKadouJikanHm) : null
        elem.joshuKosokuJikan = ![null, ''].includes(elem.joshuKosokuJikanHm) ? filter.timeToMinFormatter(elem.joshuKosokuJikanHm) : null
        elem.joshuKyukeiJikan = ![null, ''].includes(elem.joshuKyukeiJikanHm) ? filter.timeToMinFormatter(elem.joshuKyukeiJikanHm) : null
        elem.joshuKadouJikan = ![null, ''].includes(elem.joshuKadouJikanHm) ? filter.timeToMinFormatter(elem.joshuKadouJikanHm) : null

        // 数値変換
        elem.hatsuchiOdoMater = ![null, ''].includes(elem.hatsuchiOdoMater) ? d2fmt.removeComma(elem.hatsuchiOdoMater) : null
        elem.chakuchiOdoMater = ![null, ''].includes(elem.chakuchiOdoMater) ? d2fmt.removeComma(elem.chakuchiOdoMater) : null
        elem.sokoKyori = ![null, ''].includes(elem.sokoKyori) ? d2fmt.removeComma(elem.sokoKyori) : null
        elem.kushaKyori = ![null, ''].includes(elem.kushaKyori) ? d2fmt.removeComma(elem.kushaKyori) : null
        elem.jisshaKyori = ![null, ''].includes(elem.jisshaKyori) ? d2fmt.removeComma(elem.jisshaKyori) : null
        elem.sosekisairyo = ![null, ''].includes(elem.sosekisairyo) ? d2fmt.removeComma(elem.sosekisairyo) : null
        elem.juchuSuryo = ![null, ''].includes(elem.juchuSuryo) ? d2fmt.removeComma(elem.juchuSuryo) : null
        elem.juchuJuryo = ![null, ''].includes(elem.juchuJuryo) ? d2fmt.removeComma(elem.juchuJuryo) : null
        elem.kihonUnchin = this.convertOutputStringToDecimal(elem.kihonUnchin)
        elem.tanka = ![null, ''].includes(elem.tanka) ? d2fmt.removeComma(elem.tanka) : null
        elem.hiwayPrice = ![null, ''].includes(elem.hiwayPrice) ? d2fmt.removeComma(elem.hiwayPrice) : null
        elem.unchinHokaKingaku = ![null, ''].includes(elem.unchinHokaKingaku) ? d2fmt.removeComma(elem.unchinHokaKingaku) : null
        elem.unchinHokaHikazei = ![null, ''].includes(elem.unchinHokaHikazei) ? d2fmt.removeComma(elem.unchinHokaHikazei) : null
        elem.jikanWarimashiKingaku = ![null, ''].includes(elem.jikanWarimashiKingaku) ? d2fmt.removeComma(elem.jikanWarimashiKingaku) : null
        elem.kyoriWarimashiKingaku = ![null, ''].includes(elem.kyoriWarimashiKingaku) ? d2fmt.removeComma(elem.kyoriWarimashiKingaku) : null
        elem.warimashiSonotaKingsku = ![null, ''].includes(elem.warimashiSonotaKingsku) ? d2fmt.removeComma(elem.warimashiSonotaKingsku) : null
        elem.yoshaKihonUnchin = ![null, ''].includes(elem.yoshaKihonUnchin) ? d2fmt.removeComma(elem.yoshaKihonUnchin) : null
        elem.yoshaHiwayPrice = ![null, ''].includes(elem.yoshaHiwayPrice) ? d2fmt.removeComma(elem.yoshaHiwayPrice) : null
        elem.yoshaUnchinHokaKingaku = ![null, ''].includes(elem.yoshaUnchinHokaKingaku) ? d2fmt.removeComma(elem.yoshaUnchinHokaKingaku) : null
        elem.yoshaUnchinHokaHikazei = ![null, ''].includes(elem.yoshaUnchinHokaHikazei) ? d2fmt.removeComma(elem.yoshaUnchinHokaHikazei) : null
        elem.seikyuKingakuGokei = this.convertOutputStringToDecimal(elem.seikyuKingakuGokei)
        elem.shiharaiKingakuGokei = this.convertOutputStringToDecimal(elem.shiharaiKingakuGokei)

        // その他設定
        elem.unchinKeisanKbnNm = elem.unchinKeisanKbnNm ?? '車建'
        elem.sagyoYoteiYmd = self.unkoYmdMultiFlg ? elem.sagyoYoteiYmd : self.conditions.sagyoYoteiYmd
        return elem
      })

      /**
       * リスト項目テキスト⇒ID/Code変換
       */
      // 配車営業所変換
      saveTargetRow.filter((elem) => {
        return ![undefined, null, ''].includes(elem.haishaEigyoshoNm)
      }).map((elem) => {
        const m = self.filteredEigyoshoList.filter(function (item) {
          return item.eigyoshoNm?.trim() === elem.haishaEigyoshoNm?.trim()
        })
        if (m.length > 0) {
          elem.haishaEigyoshoId = m[0].id
        }
        return elem
      })

      // 売上営業所変換
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.juchuEigyoshoNm)
      }).map((elem) => {
        const m = self.filteredEigyoshoList.filter(function (item) {
          return item.eigyoshoNm?.trim() === elem.juchuEigyoshoNm?.trim()
        })
        if (m.length > 0) {
          elem.juchuEigyoshoId = m[0].id
        } else {
          elem.juchuEigyoshoId = null
        }
        return elem
      })

      // 売上部門変換
      saveTargetRow.filter((elem) => {
        return ![undefined, null, ''].includes(elem.juchuBumonNm)
      }).map((elem) => {
        const m = self.filteredEigyoshoList.filter(function (item) {
          return item.eigyoshoNm?.trim() === elem.juchuBumonNm?.trim()
        })
        if (m.length > 0) {
          elem.juchuBumonId = m[0].id
        }
        return elem
      })

      // 配車先
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.haishaKbnNm)
      }).map((elem) => {
        if (elem.haishaKbnNm === '自社') {
          elem.haishaKbn = '02'
        } else if (elem.haishaKbnNm === '傭車') {
          elem.haishaKbn = '03'
        } else {
          elem.haishaKbn = null
        }
        return elem
      })

      // 発注先
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.hacchusakiNm)
      }).map((elem) => {
        const m = self.filteredHacchusakiList.filter(function (item) {
          return item.torihikisakiNm?.trim() === elem.hacchusakiNm?.trim()
        })
        if (m.length > 0) {
          elem.hacchusakiId = m[0].id
        } else {
          elem.hacchusakiId = null
        }
        return elem
      })

      // 傭車車種
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.hacchusakiShashuSbtNm)
      }).map((elem) => {
        const m = self.shubetsuList.filter(function (item) {
          return item.kaishaCd === self.currentKaishaCode && item.sbtShuruiCd === 'GVI011' && item.sbtNm?.trim() === elem.hacchusakiShashuSbtNm?.trim()
        })
        if (m.length > 0) {
          elem.hacchusakiShashuSbt = m[0].sbtCd
        } else {
          elem.hacchusakiShashuSbt = null
        }
        return elem
      })

      // 乗務員
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.jininNm1)
      }).map((elem) => {
        const m = self.eigyoshoJininList.filter(function (item) {
          return item.jininNmSei?.trim() === elem.jininNm1?.trim()
        })
        if (m.length > 0) {
          elem.jininId1 = m[0].id
        } else {
          elem.jininId1 = null
        }
        return elem
      })

      // 同乗者
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.jininNm2)
      }).map((elem) => {
        const m = self.eigyoshoJininList.filter(function (item) {
          return item.jininNmSei?.trim() === elem.jininNm2?.trim()
        })
        if (m.length > 0) {
          elem.jininId2 = m[0].id
        } else {
          elem.jininId2 = null
        }
        return elem
      })

      // 車両変換
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.jidoshaHyojiNm)
      }).map((elem) => {
        const m = self.sharyoList.filter(function (item) {
          return item.jidoshaHyojiNm?.trim() === elem.jidoshaHyojiNm?.trim()
        })
        if (m.length > 0) {
          elem.sharyoId = m[0].id
        } else {
          elem.sharyoId = null
        }
        return elem
      })

      // 受注営業所変換
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.juchuEigyoshoNm)
      }).map((elem) => {
        const m = self.filteredEigyoshoList.filter(function (item) {
          return item.eigyoshoNm?.trim() === elem.juchuEigyoshoNm?.trim()
        })
        if (m.length > 0) {
          elem.juchuEigyoshoId = m[0].id
        } else {
          elem.juchuEigyoshoId = null
        }
        return elem
      })

      // 荷主
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.tokuisakiNm)
      }).map((elem) => {
        const m = self.torihikisakiList.filter(function (item) {
          return item.torihikisakiNm?.trim() === elem.tokuisakiNm?.trim()
        })
        if (m.length > 0) {
          elem.tokuisakiId = m[0].id
        } else {
          elem.tokuisakiId = null
        }
        return elem
      })

      // 荷受人
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.niukeninNm)
      }).map((elem) => {
        const m = self.torihikisakiList.filter(function (item) {
          return item.torihikisakiNm?.trim() === elem.niukeninNm?.trim()
        })
        if (m.length > 0) {
          elem.niukeninId = m[0].id
        } else {
          elem.niukeninId = null
        }
        return elem
      })

      // 卸先
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.oroshisakiNm)
      }).map((elem) => {
        const m = self.torihikisakiList.filter(function (item) {
          return item.torihikisakiNm?.trim() === elem.oroshisakiNm?.trim()
        })
        if (m.length > 0) {
          elem.oroshisakiId = m[0].id
        } else {
          elem.oroshisakiId = null
        }
        return elem
      })

      // 発地
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.hatsuchiNm)
      }).map((elem) => {
        const m = self.hacchakuchiList.filter(function (item) {
          return item.hacchakuchiNm?.trim() === elem.hatsuchiNm?.trim()
        })
        if (m.length > 0) {
          elem.hatsuchiId = m[0].id
        } else {
          elem.hatsuchiId = null
        }
        return elem
      })

      // 着地
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.chakuchiNm)
      }).map((elem) => {
        const m = self.hacchakuchiList.filter(function (item) {
          return item.hacchakuchiNm?.trim() === elem.chakuchiNm?.trim()
        })
        if (m.length > 0) {
          elem.chakuchiId = m[0].id
        } else {
          elem.chakuchiId = null
        }
        return elem
      })

      // 経由地１
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.keiyuchiNm1)
      }).map((elem) => {
        const m = self.hacchakuchiList.filter(function (item) {
          return item.hacchakuchiNm?.trim() === elem.keiyuchiNm1?.trim()
        })
        if (m.length > 0) {
          elem.keiyuchiId1 = m[0].id
        } else {
          elem.keiyuchiId1 = null
        }
        return elem
      })

      // 経由地２
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.keiyuchiNm2)
      }).map((elem) => {
        const m = self.hacchakuchiList.filter(function (item) {
          return item.hacchakuchiNm?.trim() === elem.keiyuchiNm2?.trim()
        })
        if (m.length > 0) {
          elem.keiyuchiId2 = m[0].id
        } else {
          elem.keiyuchiId2 = null
        }
        return elem
      })

      // 経由地３
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.keiyuchiNm3)
      }).map((elem) => {
        const m = self.hacchakuchiList.filter(function (item) {
          return item.hacchakuchiNm?.trim() === elem.keiyuchiNm3?.trim()
        })
        if (m.length > 0) {
          elem.keiyuchiId3 = m[0].id
        } else {
          elem.keiyuchiId3 = null
        }
        return elem
      })

      // 経由地４
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.keiyuchiNm4)
      }).map((elem) => {
        const m = self.hacchakuchiList.filter(function (item) {
          return item.hacchakuchiNm?.trim() === elem.keiyuchiNm4?.trim()
        })
        if (m.length > 0) {
          elem.keiyuchiId4 = m[0].id
        } else {
          elem.keiyuchiId4 = null
        }
        return elem
      })

      // 経由地５
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.keiyuchiNm5)
      }).map((elem) => {
        const m = self.hacchakuchiList.filter(function (item) {
          return item.hacchakuchiNm?.trim() === elem.keiyuchiNm5?.trim()
        })
        if (m.length > 0) {
          elem.keiyuchiId5 = m[0].id
        } else {
          elem.keiyuchiId5 = null
        }
        return elem
      })

      // 品目種別
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.hinmokuSbtNm)
      }).map((elem) => {
        const m = self.shubetsuList.filter(function (item) {
          return item.kaishaCd === self.currentKaishaCode && item.sbtShuruiCd === 'GVIJ02' && item.sbtNm?.trim() === elem.hinmokuSbtNm?.trim()
        })
        if (m.length > 0) {
          elem.hinmokuSbt = m[0].sbtCd
        } else {
          elem.hinmokuSbt = null
        }
        return elem
      })

      // 商品
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.hinmeiNm)
      }).map((elem) => {
        const m = self.hinmeiList.filter(function (item) {
          return item.hinmeiNm?.trim() === elem.hinmeiNm?.trim()
        })
        if (m.length > 0) {
          elem.mstHinmeiId = m[0].id
        } else {
          elem.mstHinmeiId = null
        }
        return elem
      })

      // 単位
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.unitKbnNm)
      }).map((elem) => {
        const m = self.shubetsuList.filter(function (item) {
          return item.kaishaCd === self.currentKaishaCode && item.sbtShuruiCd === 'SVI001' && item.sbtNm?.trim() === elem.unitKbnNm?.trim()
        })
        if (m.length > 0) {
          elem.unitKbn = m[0].sbtCd
        } else {
          elem.unitKbn = null
        }
        return elem
      })

      // 運賃計算区分
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.unchinKeisanKbnNm)
      }).map((elem) => {
        const m = self.kubunList.filter(function (item) {
          return item.kaishaCd === self.currentKaishaCode && item.kbnShuruiCd === 'SFF055' && item.codeNm?.trim() === elem.unchinKeisanKbnNm?.trim()
        })
        if (m.length > 0) {
          elem.unchinKeisanKbn = m[0].code
        } else {
          elem.unchinKeisanKbn = null
        }
        return elem
      })

      // 請求車種
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.seikyuShashuSbtNm)
      }).map((elem) => {
        const m = self.shubetsuList.filter(function (item) {
          return item.kaishaCd === self.currentKaishaCode && item.sbtShuruiCd === 'GVI011' && item.sbtNm?.trim() === elem.seikyuShashuSbtNm?.trim()
        })
        if (m.length > 0) {
          elem.seikyuShashuSbt = m[0].sbtCd
        } else {
          elem.seikyuShashuSbt = null
        }
        return elem
      })

      // 荷姿種別
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.nisugataSbtNm)
      }).map((elem) => {
        const m = self.shubetsuList.filter(function (item) {
          return item.kaishaCd === self.currentKaishaCode && item.sbtShuruiCd === 'SBT019' && item.sbtNm?.trim() === elem.nisugataSbtNm?.trim()
        })
        if (m.length > 0) {
          elem.nisugataId = m[0].id
        } else {
          elem.nisugataId = null
        }
        return elem
      })

      // 支払方法種別
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.shiharaiKbnNm)
      }).map((elem) => {
        const m = self.shubetsuList.filter(function (item) {
          return item.kaishaCd === self.currentKaishaCode && item.sbtShuruiCd === 'SBT021' && item.sbtNm?.trim() === elem.shiharaiKbnNm?.trim()
        })
        if (m.length > 0) {
          elem.shiharaiKbn = m[0].sbtCd
        } else {
          elem.shiharaiKbn = null
        }
        return elem
      })

      // 注文書受領方法
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.chumonshoReceiveSbtNm)
      }).map((elem) => {
        const m = self.shubetsuList.filter(function (item) {
          return item.kaishaCd === self.currentKaishaCode && item.sbtShuruiCd === 'SBT062' && item.sbtNm?.trim() === elem.chumonshoReceiveSbtNm?.trim()
        })
        if (m.length > 0) {
          elem.chumonshoReceiveSbt = m[0].sbtCd
        } else {
          elem.chumonshoReceiveSbt = null
        }
        return elem
      })

      // 元請け先連絡方法
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.motoukeRenrakuSbtNm)
      }).map((elem) => {
        const m = self.shubetsuList.filter(function (item) {
          return item.kaishaCd === self.currentKaishaCode && item.sbtShuruiCd === 'SBT062' && item.sbtNm?.trim() === elem.motoukeRenrakuSbtNm?.trim()
        })
        if (m.length > 0) {
          elem.motoukeRenrakuSbt = m[0].sbtCd
        } else {
          elem.motoukeRenrakuSbt = null
        }
        return elem
      })

      // 運送扱い
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.unsoAtsukaiSbtNm)
      }).map((elem) => {
        const m = self.shubetsuList.filter(function (item) {
          return item.kaishaCd === self.currentKaishaCode && item.sbtShuruiCd === 'SBT064' && item.sbtNm?.trim() === elem.unsoAtsukaiSbtNm?.trim()
        })
        if (m.length > 0) {
          elem.unsoAtsukaiSbt = m[0].sbtCd
        } else {
          elem.unsoAtsukaiSbt = null
        }
        return elem
      })

      // 入金方法区分
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.nyukinKbnNm)
      }).map((elem) => {
        const m = self.kubunList.filter(function (item) {
          return item.kaishaCd === self.currentKaishaCode && item.kbnShuruiCd === 'SFF061' && item.codeNm?.trim() === elem.nyukinKbnNm?.trim()
        })
        if (m.length > 0) {
          elem.nyukinKbn = m[0].code
        } else {
          elem.nyukinKbn = null
        }
        return elem
      })

      // 支払方法区分
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.shiharaiHohoKbnNm)
      }).map((elem) => {
        const m = self.kubunList.filter(function (item) {
          return item.kaishaCd === self.currentKaishaCode && item.kbnShuruiCd === 'SFF061' && item.codeNm?.trim() === elem.shiharaiHohoKbnNm?.trim()
        })
        if (m.length > 0) {
          elem.shiharaiHohoKbn = m[0].code
        } else {
          elem.shiharaiHohoKbn = null
        }
        return elem
      })

      // 往復
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.ohfukuSbtNm)
      }).map((elem) => {
        const m = self.shubetsuList.filter(function (item) {
          return item.kaishaCd === self.currentKaishaCode && item.sbtShuruiCd === 'SBT006' && item.sbtNm?.trim() === elem.ohfukuSbtNm?.trim()
        })
        if (m.length > 0) {
          elem.ohfukuSbt = m[0].sbtCd
        } else {
          elem.ohfukuSbt = null
        }
        return elem
      })

      // 品質
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.hinsitsuSbtNm)
      }).map((elem) => {
        const m = self.shubetsuList.filter(function (item) {
          return item.kaishaCd === self.currentKaishaCode && item.sbtShuruiCd === 'SBT006' && item.sbtNm?.trim() === elem.hinsitsuSbtNm?.trim()
        })
        if (m.length > 0) {
          elem.hinsitsuSbt = m[0].sbtCd
        } else {
          elem.hinsitsuSbt = null
        }
        return elem
      })

      // 着地
      saveTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.teikeiCourseNm)
      }).map((elem) => {
        const m = self.teikeiCourseList.filter(function (item) {
          return item.teikeiCourseNm?.trim() === elem.teikeiCourseNm?.trim()
        })
        if (m.length > 0) {
          elem.mstCourseId = m[0].id
        } else {
          elem.mstCourseId = null
        }
        return elem
      })
      /**
       * 保存処理
       */
      this.targetList = saveTargetRow
      this.$nextTick(function () {
        self.saveAction()
      })
    },

    saveAction: function () {
      const self = this
      const opt = {
        registerRequestPromise: function () {
          return self.HttpClient.put('/api/v1/D2plmd1000/BatchRegister', self.targetList, true)
        },
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.Effects.loadComplete()

            this.$nextTick(function () {
              this.searchAction(true)
            })
            resolve()
          })
        },
        getIdMethod: () => {
          return 0
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0
          }
        },
        isUpdateModeMethod: function () {
          return true
        },
        isNoRefreshModeMethod: function () {
          return true
        },
        isNoMessageModeMethod: function () {
          return false
        },
        getSavedInputMethod: function () {
          return true
        }
      }
      this.register(opt)
    },
    convertOutputStringToDecimal: function (val) {
      if ([undefined, null, ''].includes(val)) return null
      if (!isNaN(val)) return val
      return d2fmt.removeComma(val.replace(' 円', ''))
    },

    /*
     * 運行日切り替え日付
     */
    sagyoYoteiYmdPrevNext: function (val) {
      this.conditions.sagyoYoteiYmd = val
    },
    onPrevNextButtonClick: function (val) {
      // this.conditions.sagyoYoteiYmd が 'YYYY/MM/DD' 形式の文字列であることを前提に処理
      const parts = String(this.conditions.sagyoYoteiYmd).split('/')
      if (parts.length !== 3) {
        console.error("運行日 の形式が 'YYYY/MM/DD' ではありません")
        return
      }

      const year = parseInt(parts[0], 10)
      const month = parseInt(parts[1], 10) - 1 // 月は0始まり
      const day = parseInt(parts[2], 10)

      const currentDate = new Date(year, month, day)

      if (isNaN(val)) {
        return
      }

      // 日数の加減算
      currentDate.setDate(currentDate.getDate() + Number(val))

      // 'YYYY/MM/DD' 形式で再フォーマット
      const yyyy = currentDate.getFullYear()
      const mm = String(currentDate.getMonth() + 1).padStart(2, '0')
      const dd = String(currentDate.getDate()).padStart(2, '0')

      this.conditions.sagyoYoteiYmd = `${yyyy}/${mm}/${dd}`

      const self = this
      this.$nextTick(() => {
        self.searchAction(false)
      })
    },

    /**
     * EXCEL出力
     */
    onXlsOutputButtonClick: function (e) {
      this.isXlsDownloader = true

      this.Effects.loadStart()

      const self = this
      self.conditions.styleType = self.conditions.layoutType
      this.HttpClient
        .requestFileByPost('/api/v1/VwCD2plmd1000/ExcelOutput', self.conditions)
        .then((data) => {
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const elem = document.getElementById('xlsdownload')
          this.isXlsDownloader = false
          self.Effects.loadComplete()
          elem.href = window.URL.createObjectURL(blob)
          elem.download = '配車表_' + ts + '.xlsx'
          elem.click()
        })
    },

    /**
     * テンプレートEXCELダウンロード
     */
    onClickDownloadTemplate: function () {
      this.HttpClient
        .requestFileByPost('/api/v1/MstXlsImportMapping/TemplateDownload')
        .then((data) => {
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const elem = document.getElementById('download')
          this.isXlsDownloader = false
          elem.href = window.URL.createObjectURL(blob)
          elem.download = 'template.xlsx'
          elem.click()
        })
    },

    /**
     * 配車帳票出力
     */
    onHaishaPrintExec: function (e) {
      this.isHaishaPdfDownloader = true
      this.isShowHaishaOutputDialog = false
      let post = ''
      let haishaChohyoConditions = {}
      if (this.haishaChohyoSbt === '0') {
        this.dispPdfNm = `配車一覧表_${this.getTimeStamp()}.pdf`
        post = '/api/v1/VwCD2plmr01101/PdfDownload'
        haishaChohyoConditions = {
          startDay: this.unkoYmdMultiFlg ? this.conditions.sagyoYoteiYmdFrom : this.conditions.sagyoYoteiYmd,
          endDay: this.unkoYmdMultiFlg ? this.conditions.sagyoYoteiYmdTo : this.conditions.sagyoYoteiYmd,
          haishaEigyoshoId: this.conditions.haishaEigyoshoId,
          haishahyoCd: this.conditions.haishahyoCd
        }
      }
      this.HttpClient
        .requestFileByPost(post, haishaChohyoConditions).then(data => {
          // aタグにファイル仕込んでClickする処理
          if (data.type === 'application/pdf') {
            const blob = new Blob([data], { type: 'application/pdf' })
            const elem = document.getElementById('pdfDownload')
            elem.href = window.URL.createObjectURL(blob)
            elem.click()
            this.setInvalidSummaryMessage('COMI0007')
            this.isHaishaPdfDownloader = false
          } else {
            this.setInvalidSummaryMessage('COMI0101')
            this.isHaishaPdfDownloader = false
          }
        })
    },
    /**
     * 納品書・受領書出力
     */
    onClickPrintExecByContextMenu: function (selectedRowsList) {
      var idList = []
      selectedRowsList.forEach((rec) => {
        idList.push(this.rows[rec].trSagyoMeisaiId)
      })
      // 重複削除
      this.printExec([...new Set(idList)])
    },
    onClickPrintExec: function (e) {
      const idList = []
      this.printExec(idList)
    },
    printExec: function (idList) {
      this.isNohinshoPdfDownloader = true
      this.isShowNohinshoOutputDialog = false
      let post = ''
      let nohinshoConditions = {}
      if (this.haishaChohyoSbt === '01') {
        this.dispPdfNm = `納品書_${this.getTimeStamp()}.pdf`
      } else if (this.haishaChohyoSbt === '02') {
        this.dispPdfNm = `受領書_${this.getTimeStamp()}.pdf`
      } else {
        this.dispPdfNm = `納品書・受領書_${this.getTimeStamp()}.pdf`
      }
      post = '/api/v1/VwCD2rcop0010/PdfDownload'
      nohinshoConditions = {
        dataKbn: this.nohinshoChohyoSbt,
        // startUnkoYmd: this.conditions.sagyoYoteiYmd,
        sagyoEigyoshoId: this.conditions.haishaEigyoshoId,
        haishahyoCd: this.conditions.haishahyoCd,
        idList: idList
      }
      this.HttpClient
        .requestFileByPost(post, nohinshoConditions).then(data => {
          // aタグにファイル仕込んでClickする処理
          if (data.type === 'application/pdf') {
            const blob = new Blob([data], { type: 'application/pdf' })
            const elem = document.getElementById('pdfDownload')
            elem.href = window.URL.createObjectURL(blob)
            elem.click()
            this.setInvalidSummaryMessage('COMI0007')
            this.isNohinshoPdfDownloader = false
          } else {
            this.setInvalidSummaryMessage('COMI0101')
            this.isNohinshoPdfDownloader = false
          }
        })
    },
    getTimeStamp () {
      var date = new Date()
      const Y = date.getFullYear()
      const M = ('00' + (date.getMonth() + 1)).slice(-2)
      const D = ('00' + date.getDate()).slice(-2)
      const h = ('00' + date.getHours()).slice(-2)
      const m = ('00' + date.getMinutes()).slice(-2)
      const s = ('00' + date.getSeconds()).slice(-2)

      return Y + M + D + h + m + s
    },

    /**
     * 運賃自動計算
     */
    onAutoCalcButtonClick: function () {
      // alert('AutoCalc')
      const self = this
      var calcTargetRow = this.rows.filter(function (elem) {
        return ![undefined, null, ''].includes(elem.tokuisakiNm) || ![undefined, null, ''].includes(elem.hatsuchiNm) || ![undefined, null, ''].includes(elem.chakuchiNm) || ![undefined, null, ''].includes(elem.hinmeiNm)
      })

      if (calcTargetRow.length < 1) {
        modals.showToast('運賃自動計算対象がありません', null, 500, null, 'warning')
        return
      }

      if ([undefined, null, ''].includes(this.computedColNumList.sagyoYoteiYmd)) {
        calcTargetRow.map((elem) => {
          elem.sagyoYoteiYmd = elem.sagyoYoteiYmd ? elem.sagyoYoteiYmd : this.conditions.sagyoYoteiYmdFrom
          return elem
        })
      }

      // 取引先変換
      calcTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.tokuisakiNm)
      }).map((elem, index) => {
        const m = self.torihikisakiList.filter(function (item) {
          return item.torihikisakiNm === elem.tokuisakiNm
        })
        elem.TorihikisakiCd = m.length > 0 ? m[0].torihikisakiCd : null
        return elem
      })

      // 発地変換
      calcTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.hatsuchiNm)
      }).map((elem) => {
        const m = self.hacchakuchiList.filter(function (item) {
          return item.hacchakuchiNm === elem.hatsuchiNm
        })
        elem.hatsuchiCd = m.length > 0 ? m[0].hacchakuchiCd : null
        return elem
      })

      // 着地
      calcTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.chakuchiNm)
      }).map((elem) => {
        const m = self.hacchakuchiList.filter(function (item) {
          return item.hacchakuchiNm === elem.chakuchiNm
        })
        elem.chakuchiCd = m.length > 0 ? m[0].hacchakuchiCd : null
        return elem
      })

      // 品目種別
      calcTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.hinmokuSbtNm)
      }).map((elem) => {
        const m = self.shubetsuList.filter(function (item) {
          return item.kaishaCd === self.currentKaishaCode && item.sbtShuruiCd === 'GVIJ02' && item.sbtNm === elem.hinmokuSbtNm
        })
        elem.hinmokuSbt = m.length > 0 ? m[0].sbtCd : null
        return elem
      })

      // 荷姿種別
      calcTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.nisugataSbtNm)
      }).map((elem) => {
        const m = self.shubetsuList.filter(function (item) {
          return item.kaishaCd === self.currentKaishaCode && item.sbtShuruiCd === 'SBT019' && item.sbtNm === elem.nisugataSbtNm
        })
        elem.nisugataSbt = m.length > 0 ? m[0].sbtCd : null
        return elem
      })

      // 商品
      calcTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.hinmeiNm)
      }).map((elem) => {
        const m = self.hinmeiList.filter(function (item) {
          return item.hinmeiNm === elem.hinmeiNm
        })
        elem.hinmeiCd = m.length > 0 ? m[0].hinmeiCd : null
        return elem
      })

      // 営業所
      calcTargetRow.filter((elem) => {
        return ![undefined, null].includes(elem.juchuEigyoshoNm)
      }).map((elem) => {
        const m = self.filteredEigyoshoList.filter(function (item) {
          return item.eigyoshoNm === elem.juchuEigyoshoNm
        })
        if (m.length > 0) {
          elem.juchuEigyoshoCd = m[0].eigyoshoCd
        } else {
          elem.juchuEigyoshoCd = null
        }
        return elem
      })

      this.HttpClient.post('/api/v1/D2plmd1000/CalcHaccakuchiSeikyuKingaku', calcTargetRow)
        .then((data) => {
          const dxList = data.payload

          if (!dxList || dxList.length < 1) {
            modals.showToast('運賃自動計算の結果がありませんでした', null, 500, null, 'warning')
            return
          }
          const dxMap = new Map(dxList.map(dx => [dx.rowNo, dx]))

          var updateFlg = false

          self.rows.forEach(row => {
            if (dxMap.has(row.rowNo)) {
              const tmp = dxMap.get(row.rowNo)
              // 戻り値単価がNullでないときのみ更新
              if (tmp !== null) {
                // 対象項目
                const fields = [
                  'unchinKeisanKbn',
                  'tanka',
                  'meisaiKihonUnchin',
                  'meisaiJikanWarimashiKingaku',
                  'meisaiKyoriWarimashiKingaku',
                  'meisaiKeisuWarimashiKingaku',
                  'meisaiNenryoWarimashiKingaku',
                  'meisaiHiwayPrice',
                  'meisaiNenryoSurcharge',
                  'meisaiTsumikomiKingaku',
                  'meisaiTorioroshiKingaku',
                  'meisaiTaikiJikanKingaku',
                  'meisaiFutaiGyomuKingaku',
                  'meisaiFutaiGyomuKingaku1',
                  'meisaiFutaiGyomuKingaku2',
                  'meisaiFutaiGyomuKingaku3',
                  'meisaiFutaiGyomuKingaku4',
                  'meisaiFutaiGyomuKingaku5',
                  'meisaiFutaiGyomuKingaku6',
                  'meisaiFutaiGyomuKingaku7',
                  'meisaiFutaiGyomuKingaku8',
                  'meisaiFutaiGyomuKingaku9',
                  'meisaiFutaiGyomuKingaku10',
                  'meisaiUserKingakuKazei1',
                  'meisaiUserKingakuKazei2',
                  'meisaiUserKingakuKazei3',
                  'meisaiUserKingakuKazei4',
                  'meisaiUserKingakuKazei5',
                  'meisaiUserKingakuKazei6',
                  'meisaiUserKingakuKazei7',
                  'meisaiUserKingakuKazei8',
                  'meisaiUserKingakuKazei9',
                  'meisaiUserKingakuKazei10',
                  'meisaiUserKingakuHikazei1',
                  'meisaiUserKingakuHikazei2',
                  'meisaiUserKingakuHikazei3',
                  'meisaiUserKingakuHikazei4',
                  'meisaiUserKingakuHikazei5',
                  'meisaiUserKingakuHikazei6',
                  'meisaiUserKingakuHikazei7',
                  'meisaiUserKingakuHikazei8',
                  'meisaiUserKingakuHikazei9',
                  'meisaiUserKingakuHikazei10',
                  'meisaiUserKingakuUchizei1',
                  'meisaiUserKingakuUchizei2',
                  'meisaiUserKingakuUchizei3',
                  'meisaiUserKingakuUchizei4',
                  'meisaiUserKingakuUchizei5',
                  'meisaiUserKingakuUchizei6',
                  'meisaiUserKingakuUchizei7',
                  'meisaiUserKingakuUchizei8',
                  'meisaiUserKingakuUchizei9',
                  'meisaiUserKingakuUchizei10',
                  'hinmokuKihonUnchin',
                  'hinmokuJikanWarimashiKingaku',
                  'hinmokuKyoriWarimashiKingaku',
                  'hinmokuKeisuWarimashiKingaku',
                  'hinmokuNenryoWarimashiKingaku',
                  'hinmokuHiwayPrice',
                  'hinmokuNenryoSurcharge',
                  'hinmokuTsumikomiKingaku',
                  'hinmokuTorioroshiKingaku',
                  'hinmokuTaikiJikanKingaku',
                  'hinmokuFutaiGyomuKingaku',
                  'hinmokuFutaiGyomuKingaku1',
                  'hinmokuFutaiGyomuKingaku2',
                  'hinmokuFutaiGyomuKingaku3',
                  'hinmokuFutaiGyomuKingaku4',
                  'hinmokuFutaiGyomuKingaku5',
                  'hinmokuFutaiGyomuKingaku6',
                  'hinmokuFutaiGyomuKingaku7',
                  'hinmokuFutaiGyomuKingaku8',
                  'hinmokuFutaiGyomuKingaku9',
                  'hinmokuFutaiGyomuKingaku10',
                  'hinmokuUserKingakuKazei1',
                  'hinmokuUserKingakuKazei2',
                  'hinmokuUserKingakuKazei3',
                  'hinmokuUserKingakuKazei4',
                  'hinmokuUserKingakuKazei5',
                  'hinmokuUserKingakuKazei6',
                  'hinmokuUserKingakuKazei7',
                  'hinmokuUserKingakuKazei8',
                  'hinmokuUserKingakuKazei9',
                  'hinmokuUserKingakuKazei10',
                  'hinmokuUserKingakuHikazei1',
                  'hinmokuUserKingakuHikazei2',
                  'hinmokuUserKingakuHikazei3',
                  'hinmokuUserKingakuHikazei4',
                  'hinmokuUserKingakuHikazei5',
                  'hinmokuUserKingakuHikazei6',
                  'hinmokuUserKingakuHikazei7',
                  'hinmokuUserKingakuHikazei8',
                  'hinmokuUserKingakuHikazei9',
                  'hinmokuUserKingakuHikazei10',
                  'hinmokuUserKingakuUchizei1',
                  'hinmokuUserKingakuUchizei2',
                  'hinmokuUserKingakuUchizei3',
                  'hinmokuUserKingakuUchizei4',
                  'hinmokuUserKingakuUchizei5',
                  'hinmokuUserKingakuUchizei6',
                  'hinmokuUserKingakuUchizei7',
                  'hinmokuUserKingakuUchizei8',
                  'hinmokuUserKingakuUchizei9',
                  'hinmokuUserKingakuUchizei10'
                ]

                fields.forEach(field => {
                  // 運賃計算区分のみ特殊分岐
                  if (self.computedColNumList[field]) {
                    const cell = self.$refs.ddSpreadSheet.getCellNameFromCoords(self.computedColNumList[field], row.rowNo - 1)

                    // 初期化
                    self.$refs.ddSpreadSheet.setCellComments(cell, 'title', null)
                    self.$refs.ddSpreadSheet.removeCellClass(self.computedColNumList[field], row.rowNo - 1, 'recalc-cell')

                    // 元値がNULLかブランクの場合に更新
                    if ([undefined, null, ''].includes(row[field]) && ![null, 0].includes(tmp[field])) {
                      row[field] = tmp[field]
                      self.$refs.ddSpreadSheet.jspreadsheetObj.setValue(cell, tmp[field], true)
                      updateFlg = true
                    } else {
                      if (row[field] !== tmp[field] && ![null, 0].includes(tmp[field])) {
                        self.$refs.ddSpreadSheet.setCellClass(self.computedColNumList[field], row.rowNo - 1, 'recalc-cell')
                        const price = filter.numericFormatter(tmp[field])
                        const msg = `マスタの設定値は ${price}円です。`
                        self.$refs.ddSpreadSheet.setCellComments(cell, 'title', msg)
                      }
                    }
                  } else if (self.computedColNumList.unchinKeisanKbnNm && field === 'unchinKeisanKbn' && ![null, ''].includes(tmp[field])) {
                    const cell = self.$refs.ddSpreadSheet.getCellNameFromCoords(self.computedColNumList.unchinKeisanKbnNm, row.rowNo - 1)

                    const t = this.kubunList.filter((elem) => {
                      return elem.kbnShuruiCd === 'SFF055' && elem.kaishaCd === self.currentKaishaCode
                    }).find(x => x.code === tmp[field])
                    if (t !== undefined) {
                      const tUnchinKeisanKbn = t.codeNm
                      if ([undefined, null, ''].includes(row.unchinKeisanKbnNm) && ![null, ''].includes(tUnchinKeisanKbn)) {
                        row.unchinKeisanKbnNm = tUnchinKeisanKbn
                        self.$refs.ddSpreadSheet.jspreadsheetObj.setValue(cell, tUnchinKeisanKbn, true)
                        updateFlg = true
                      }
                    }
                  }
                })
              }
            }
          })
          if (updateFlg) {
            modals.showToast('運賃を自動計算しました', null, 500, null, null)
          } else {
            modals.showToast('運賃の自動計算が適用されませんでした', null, 500, null, null)
          }
        })
    },

    onChangeListType: function (type) {
      const d = new Date()
      this.unkoYmdMultiFlg = type
      const keyToDelete = type ? 'sagyoYoteiYmd' : 'unkoYmdFromTo'
      const keyToAdd = type ? 'unkoYmdFromTo' : 'sagyoYoteiYmd'

      this.conditionDetails = this.conditionDetails.filter(item => item.key !== keyToDelete)

      if (!this.conditionDetails.some(item => item.key === keyToAdd)) {
        this.conditionDetails.splice(1, 0, { key: keyToAdd, name: '運行日', value: keyToAdd, delete: false })
      }

      if (type) {
        this.$set(this.conditions, 'sagyoYoteiYmdFrom', date.getFirstDate(d.getFullYear(), d.getMonth() + 1))
        this.$set(this.conditions, 'sagyoYoteiYmdTo', date.getLastDate(d.getFullYear(), d.getMonth() + 1))
      } else {
        this.$set(this.conditions, 'sagyoYoteiYmd', date.getCurrentDate())
      }

      if (!this.$refs.layoutType) {
        this.conditions.layoutType = type ? 'D2PLMD1011' : 'D2PLMD1010'
      }
      const p = Object.assign([], this.rows)
      this.headers = []
      this.rows = []
      this.setHeader().then(() => {
        this.rows = Object.assign([], p)
        this.rows.map((elem, index) => {
          // 請求金額・支払金額関数埋め込み
          const y = index + 1
          elem.seikyuKingakuGokeiFormula = ![undefined, null, ''].includes(this.seikyuKingakuGokeiFormula) ? '=' + this.seikyuKingakuGokeiFormula.replaceAll('{rowNo}', `${y}`) : ''
          elem.shiharaiKingakuGokeiFormula = ![undefined, null, ''].includes(this.shiharaiKingakuGokeiFormula) ? '=' + this.shiharaiKingakuGokeiFormula.replaceAll('{rowNo}', `${y}`) : ''
          return elem
        })
        this.$nextTick(() => {
          const fixedHeaderColumns = this.headers.filter(x => x.fixedHeader).length
          if (this.$refs.ddSpreadSheet) {
            this.$refs.ddSpreadSheet.setFreezeColumns(fixedHeaderColumns > 0 ? fixedHeaderColumns : 1)
          }
        })
      })
    },
    // テンプレート登録ダイアログ
    onTemplateRegisterButtonClick: function () {
      const saveTargetRow = this.rows.filter(function (elem) {
        return elem.editFlg === true && elem.errFlg !== true
      })
      if (saveTargetRow.length < 1) {
        modals.showToast('保存対象がありません', null, 500, null, 'warning')
        return
      }
      this.isShowXlsTemplateEditDialog = true
    },
    onTemplateRegisterDialogCloseClick: function () {
      this.isShowXlsTemplateEditDialog = false
    },
    // テンプレート検索ダイアログ
    onTemplateLoadButtonClick: function () {
      this.isShowXlsTemplateSearchDialog = true
    },
    onTemplateLoadDialogCloseClick: function () {
      this.isShowXlsTemplateSearchDialog = false
    },
    setTemplateRow: function (elem) {
      // dropdown項目の候補にない値はセットしない
      const dropdownColumnList = this.headers.filter(item => item.type === 'dropdown')
      dropdownColumnList.forEach(item => {
        // sourceはオブジェクト配列{ id: xxx, name: xxx }の場合もある
        const source = item.source?.map(s => s?.id !== undefined ? s.id : s)
        const value = elem[item.name]
        if (!source.includes(value)) {
          elem[item.name] = null
        }
      })

      return elem
    },
    addTemplateRows: function (rowList) {
      // 未入力行の末尾からデータを展開
      var maxInputRowNo = Math.max(...this.rows.filter(elem => elem.editFlg).map(elem => elem.rowNo), 0)
      rowList.forEach(elem => {
        maxInputRowNo += 1
        // もしも空行なら何もしない
        if (Object.keys(elem).length === 0) { return }

        var newrow = {
          ...this.setNewRow(),
          ...this.setTemplateRow(elem),
          rowNo: maxInputRowNo,
          editFlg: true
        }
        var targetRowIndex = this.rows.findIndex(item => item.rowNo === maxInputRowNo)
        if (targetRowIndex >= 0) {
          // 行置き換え
          this.rows.splice(targetRowIndex, 1, newrow)
        } else {
          // 行追加
          this.rows.splice(this.rows.length, 0, newrow)
        }
      })
    },
    addTemplateRowsAfter: function (rowList) {
      // 行番号が狂うので外部からのエラー設定は消去
      this.outsideErrorList = []
      // 計算式関数見直し
      const self = this
      this.rows.forEach((rec, index) => {
        rec.seikyuKingakuGokeiFormula = ![undefined, null, ''].includes(self.seikyuKingakuGokeiFormula) ? '=' + self.seikyuKingakuGokeiFormula.replaceAll('{rowNo}', `${index + 1}`) : ''
        rec.shiharaiKingakuGokeiFormula = ![undefined, null, ''].includes(self.shiharaiKingakuGokeiFormula) ? '=' + self.shiharaiKingakuGokeiFormula.replaceAll('{rowNo}', `${index + 1}`) : ''
      })
      // 追加した行を選択してあげる
      var maxInputRowNo = Math.max(...this.rows.filter(elem => elem.editFlg).map(elem => elem.rowNo), 0)
      const x1 = 0
      const y1 = maxInputRowNo - rowList.length
      const x2 = this.headers.length - 1
      const y2 = maxInputRowNo - 1
      this.selectNewRows(x1, y1, x2, y2)
      // changeイベントの実行 ※計算処理が行われていたためそれを実行したい
      setTimeout(() => {
        this.rows.forEach((elem, y) => {
          if (y1 <= y && y <= y2) {
            this.headers.forEach((column, x) => {
              this.changeAfter(elem, null, x, y, elem[column.name], null)
            })
          }
        })
      }, 10)
    },
    selectNewRows: function (x1, y1, x2, y2) {
      // setTimeoutを0msでもいいからかますと描画タイミングがよろしくなる → 10msにしてるのは後続処理のtoastメッセージを考慮
      setTimeout(() => {
        const ref = this.$refs.ddSpreadSheet
        if (ref) {
          const ws = ref.jspreadsheetObj.getWorksheetActive()
          const wss = ref.jspreadsheetObj.getWorksheetInstance(ws)

          const pageSize = wss.options.pagination
          const currentPage = wss.pageNumber
          const page = Math.floor(y2 / pageSize)
          if (currentPage !== page) {
            // ページの移動
            wss.page(page)
            this.$refs.ddSpreadSheet.jspreadsheetObj.goto(y2, x2)
          } else {
            // スクロール外の行を選択状態にすると表示がおかしくなってしまうため、その場合は「goto」で指定行に移動させる
            const content = wss.content
            const thead = wss.thead
            const contentHeight = content.clientHeight
            const theadHeight = thead.clientHeight
            // 1行の高さ
            const rowHeight = 26
            const rowTop = ((y2 - pageSize * currentPage) * rowHeight) + theadHeight
            const scrollTop = wss.content.scrollTop
            const containerHeight = contentHeight
            const isRowVisible = this.isRowVisible(rowTop, rowHeight, scrollTop, containerHeight)
            if (!isRowVisible) {
              this.$refs.ddSpreadSheet.jspreadsheetObj.goto(y2, x2)
            }
          }
          // セルを選択
          this.$refs.ddSpreadSheet.jspreadsheetObj.updateSelectionFromCoords(x1, y1, x2, y2)
        }
      }, 10)
    },
    isRowVisible: function (rowTop, rowHeight, scrollTop, containerHeight) {
      const rowBottom = rowTop + rowHeight
      const viewBottom = scrollTop + containerHeight

      return rowBottom > scrollTop && rowTop < viewBottom
    },
    onTemplateLoadDialogSelectClick: function (rowList) {
      this.isShowXlsTemplateSearchDialog = false
      if (!rowList.length) {
        modals.showToast('追加するデータがありません', null, 500, null, 'info')
        return
      }
      // 行追加処理
      this.addTemplateRows(rowList)
      // 行追加後処理
      this.addTemplateRowsAfter(rowList)

      modals.showToast('テンプレートからデータを追加しました', null, 500, null, 'info')
    },
    onSort: function (worksheet, column, direction, newOrderValues) {
      this.isSorting = true

      this.$nextTick(() => {
        setTimeout(() => {
          try {
            const sortedRows = newOrderValues.map(oldIndex => {
              return this.rows[oldIndex]
            })

            for (let index = 0; index < sortedRows.length; index++) {
              const row = sortedRows[index]
              const rowNo = `${index + 1}`

              if (row.seikyuKingakuGokeiFormula) {
                row.seikyuKingakuGokeiFormula = '=' + this.seikyuKingakuGokeiFormula.split('{rowNo}').join(rowNo)
              }

              if (row.shiharaiKingakuGokeiFormula) {
                row.shiharaiKingakuGokeiFormula = '=' + this.shiharaiKingakuGokeiFormula.split('{rowNo}').join(rowNo)
              }
            }
            this.rows = sortedRows
          } finally {
            this.isSorting = false
          }
        }, 0)
      })
    },
    setInitializeInputValueIfBlank: function (y) {
      const self = this

      self.headers.forEach(header => {
        if ([undefined, null, ''].includes(header.initializeInputValue)) return

        const col = self.computedColNumList[header.name]
        if ([undefined, null].includes(col)) return

        const cellName = self.$refs.ddSpreadSheet.getCellNameFromCoords(col, Number(y))
        const currentValue = self.$refs.ddSpreadSheet.jspreadsheetObj.getValue(cellName)

        // すでに値が入っている場合は入力値を優先
        if (![undefined, null, ''].includes(currentValue)) return

        self.$refs.ddSpreadSheet.jspreadsheetObj.setValue(cellName, header.initializeInputValue, true)
      })
    }
  }
}
